import { createIcon } from '@chakra-ui/icons';

export const AdobexdLogo = createIcon({
	displayName: 'AdobexdLogo',
	viewBox: '0 0 24 24',
	path: (
		<g clipPath='url(#clip0)'>
			<path
				d='M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z'
				fill='#470137'
			/>
			<path
				d='M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z'
				fill='#FF61F6'
			/>
		</g>
	)
});
export const AppleLogo = createIcon({
	displayName: 'AppleLogo',
	viewBox: '0 0 15 18',
	path: (
		<g width='15' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#Apple_logo_black 1__a)'>
				<path
					d='M12.507 17.28c-.966.947-2.031.8-3.046.353-1.08-.456-2.067-.484-3.207 0-1.42.619-2.173.439-3.029-.353C-1.602 12.258-.89 4.608 4.597 4.32c1.33.072 2.263.743 3.046.8 1.166-.24 2.28-.926 3.528-.836 1.498.122 2.619.72 3.367 1.795-3.082 1.872-2.352 5.976.479 7.128-.566 1.503-1.293 2.988-2.512 4.086l.002-.013ZM7.537 4.266C7.392 2.034 9.183.198 11.242.018c.283 2.574-2.316 4.5-3.705 4.248Z'
					fill='currentColor'
				/>
			</g>
			<defs>
				<clipPath id='Apple_logo_black 1__a'>
					<path fill='currentColor' d='M0 0h15v18H0z' />
				</clipPath>
			</defs>
		</g>
	)
});
export const AndroidLogo = createIcon({
	displayName: 'AndroidLogo',
	viewBox: '0 0 16 18',
	path: (
		<g width='16' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M4.9.051a.571.571 0 0 0-.263.066.518.518 0 0 0-.214.715l.595 1.029C3.584 2.71 2.634 4.16 2.634 5.815v.307a1.525 1.525 0 0 0-1.132-.494C.672 5.628 0 6.27 0 7.064v4.426c0 .793.673 1.437 1.502 1.437.452 0 .857-.192 1.132-.495v.62c0 .836.715 1.52 1.588 1.52h.404v1.969c0 .793.672 1.436 1.501 1.436.829 0 1.502-.643 1.502-1.436v-1.97h.697v1.97c0 .793.673 1.436 1.502 1.436.828 0 1.501-.643 1.501-1.436v-1.97h.403c.874 0 1.588-.683 1.588-1.519v-.62c.276.303.68.495 1.133.495.829 0 1.502-.644 1.502-1.437V7.064c0-.793-.673-1.436-1.502-1.436-.452 0-.857.191-1.133.494v-.307c0-1.655-.952-3.104-2.385-3.953l.596-1.03a.518.518 0 0 0-.214-.715.571.571 0 0 0-.748.205L9.945 1.4a5.906 5.906 0 0 0-1.968-.333c-.692 0-1.357.117-1.967.332L5.386.322a.556.556 0 0 0-.487-.27Z'
				fill='#fffcurrentColor'
			/>
			<path
				d='M1.501 6.002c-.618 0-1.11.47-1.11 1.062v4.426c0 .592.492 1.063 1.11 1.063.618 0 1.11-.471 1.11-1.063V7.064c0-.591-.492-1.062-1.11-1.062Zm12.952 0c-.619 0-1.11.47-1.11 1.062v4.426c0 .592.491 1.063 1.11 1.063.618 0 1.11-.471 1.11-1.063V7.064c0-.591-.492-1.062-1.11-1.062Zm-8.327 5.05c-.618 0-1.11.471-1.11 1.063v4.426c0 .591.492 1.062 1.11 1.062.618 0 1.11-.47 1.11-1.062v-4.426c0-.592-.492-1.063-1.11-1.063Zm3.7 0c-.618 0-1.11.471-1.11 1.063v4.426c0 .591.492 1.062 1.11 1.062.619 0 1.111-.47 1.111-1.062v-4.426c0-.592-.492-1.063-1.11-1.063Z'
				fill='currentColor'
			/>
			<path
				d='M4.9.426a.16.16 0 0 0-.074.02.141.141 0 0 0-.061.204l.782 1.352c-1.505.75-2.522 2.174-2.524 3.808h9.905c-.003-1.634-1.02-3.058-2.524-3.808L11.186.65c.044-.076.018-.163-.061-.205a.16.16 0 0 0-.075-.02.157.157 0 0 0-.14.079l-.792 1.367a5.483 5.483 0 0 0-2.143-.43c-.767 0-1.494.154-2.142.43L5.04.504A.157.157 0 0 0 4.9.426ZM3.024 6.184v6.868c0 .635.534 1.146 1.198 1.146h7.51c.663 0 1.197-.511 1.197-1.146V6.184H3.023Z'
				fill='currentColor'
			/>
			<path
				d='M5.69 3.285a.407.407 0 0 0-.413.395c0 .216.187.395.414.395a.407.407 0 0 0 .413-.395.407.407 0 0 0-.413-.395Zm4.572 0a.407.407 0 0 0-.414.395c0 .216.188.395.414.395a.407.407 0 0 0 .413-.395.407.407 0 0 0-.413-.395Z'
				fill='currentColor'
			/>
		</g>
	)
});
export const WindowsLogo = createIcon({
	displayName: 'WindowsLogo',
	viewBox: '0 0 19 18',
	path: (
		<g width='19' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='m0 2.537 7.705-.994.004 7.04-7.702.042L0 2.537Zm7.701 6.858.006 7.047L.006 15.44V9.348l7.695.047Zm.935-7.982L18.852 0v8.494l-10.216.077V1.413ZM18.854 9.46l-.002 8.456L8.636 16.55l-.015-7.106 10.233.016Z'
				fill='currentColor'
			/>
		</g>
	)
});

export const AtlassianLogo = createIcon({
	displayName: 'AtlassianLogo',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				d='M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z'
				fill='#2684FF'
			/>
			<path
				d='M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z'
				fill='#2684FF'
			/>
		</g>
	)
});

export const CartIcon = createIcon({
	displayName: 'CartIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z'
		/>
	)
});

export const ClockIcon = createIcon({
	displayName: 'ClockIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<g>
				<rect fill='none' height='24' width='24' />
			</g>
			<g>
				<g>
					<g>
						<path
							fill='currentColor'
							d='M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z'
						/>
					</g>
				</g>
			</g>
		</g>
	)
});

export const CreditIcon = createIcon({
	displayName: 'CreditIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z'
		/>
	)
});

export const DashboardLogo = createIcon({
	displayName: 'DashboardLogo',
	viewBox: '0 0 1000 257',
	path: (
		<g width='998' height='257' viewBox='0 0 998 257' fill='none'>
			<g clipPath='url(#clip0)'>
				<path
					d='M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z'
					fill='currentColor'
				/>
				<path
					d='M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z'
					fill='currentColor'
				/>
				<path
					d='M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z'
					fill='currentColor'
				/>
				<path
					d='M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z'
					fill='currentColor'
				/>
				<path
					d='M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z'
					fill='currentColor'
				/>
				<path
					d='M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z'
					fill='currentColor'
				/>
				<rect width='257' height='257' rx='128.5' fill='#4FD1C5' />
				<path
					d='M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z'
					fill='white'
				/>
			</g>
			<defs>
				<linearGradient id='paint0_linear' x1='128.5' y1='0' x2='128.5' y2='257' gradientUnits='userSpaceOnUse'>
					<stop stop-color='#7BCBD4' />
					<stop offset='1' stop-color='#29C6B7' />
				</linearGradient>
				<clipPath id='clip0'>
					<rect width='997.832' height='257' fill='white' />
				</clipPath>
			</defs>
		</g>
	)
});

export const DashboardLogoWhite = createIcon({
	displayName: 'DashboardLogo',
	viewBox: '0 0 163.5 42',
	path: (
		<g fill='none'>
			<path
				d='M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z'
				fill='#fff'
			/>
			<path
				d='M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z'
				fill='#3BCBBE'
			/>
		</g>
	)
});

export const DocumentIcon = createIcon({
	displayName: 'DocumentIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				fill='currentColor'
				d='M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z'
			/>
			<path
				fill='currentColor'
				d='M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z'
			/>
		</g>
	)
});

export const GlobeIcon = createIcon({
	displayName: 'GlobeIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				stroke='currentColor'
				fill='transparent'
				d='M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z'
				strokeWidth='.75'
				stroke-miterlimit='10'
			/>
			<path
				stroke='currentColor'
				fill='transparent'
				d='M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z'
				strokeWidth='.75'
				stroke-miterlimit='10'
			/>
			<path
				stroke='currentColor'
				fill='transparent'
				d='M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904'
			/>
			<path
				stroke='currentColor'
				fill='transparent'
				d='M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904'
				strokeWidth='.75'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				stroke='currentColor'
				fill='transparent'
				d='M11.25 2.109v18.28M20.39 11.249H2.11'
				strokeWidth='.75'
				stroke-miterlimit='10'
			/>
		</g>
	)
});

export const HelpIcon = createIcon({
	displayName: 'HelpIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z'
		/>
	)
});

export const HomeIcon = createIcon({
	displayName: 'HomeIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				fill='currentColor'
				d='M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z'
			/>
			<path
				fill='currentColor'
				d='M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z'
			/>
		</g>
	)
});

export const InvisionLogo = createIcon({
	displayName: 'InvisionLogo',
	viewBox: '0 0 24 24',
	path: (
		<g clipPath='url(#clip0)'>
			<path
				d='M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z'
				fill='#DC395F'
			/>
			<path
				d='M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74'
				fill='#fff'
			/>
		</g>
	)
});

export const JiraLogo = createIcon({
	displayName: 'JiraLogo',
	viewBox: '0 0 24 24',
	path: (
		<g clipPath='url(#clip0)'>
			<path
				d='M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z'
				fill='#2684FF'
			/>
			<path
				d='M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z'
				fill='url(#paint0_linear)'
			/>
			<path
				d='M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z'
				fill='url(#paint1_linear)'
			/>
		</g>
	)
});

export const MastercardIcon = createIcon({
	displayName: 'MastercardIcon',
	viewBox: '0 0 24 24',
	path: (
		<svg width='24' height='20' viewBox='0 0 21 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx='6.63158' cy='7.49999' r='6.63158' fill='#EB001B' />
			<circle cx='14.3686' cy='7.49999' r='6.63158' fill='#F79E1B' />
		</svg>
	)
});

export const PayPalIcon = createIcon({
	displayName: 'PayPalIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				fill='currentColor'
				d='M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z'
			/>
			<path
				fill='currentColor'
				d='M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z'
			/>
		</g>
	)
});

export const PersonIcon = createIcon({
	displayName: 'PersonIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z'
		/>
	)
});

export const ProfileIcon = createIcon({
	displayName: 'ProfileIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path d='M0 0h24v24H0V0z' fill='transparent' />
			<path
				fill='currentColor'
				d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z'
			/>
		</g>
	)
});

export const RocketIcon = createIcon({
	displayName: 'RocketIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				fill='currentColor'
				d='M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z'
			/>
			<path
				fill='currentColor'
				d='M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z'
			/>
		</g>
	)
});

export const SettingsIcon = createIcon({
	displayName: 'SettingsIcon',
	viewBox: '0 0 24 24',
	// path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
	path: (
		<g>
			<path d='M0,0h24v24H0V0z' fill='none' />
			<path
				fill='currentColor'
				d='M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z'
			/>
		</g>
	)
});

export const SlackLogo = createIcon({
	displayName: 'SlackLogo',
	viewBox: '0 0 24 24',
	path: (
		<g clipPath='url(#clip0)' fill-rule='evenodd' clip-rule='evenodd'>
			<path
				d='M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z'
				fill='#36C5F0'
			/>
			<path
				d='M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z'
				fill='#2EB67D'
			/>
			<path
				d='M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z'
				fill='#ECB22E'
			/>
			<path
				d='M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z'
				fill='#E01E5A'
			/>
		</g>
	)
});

export const SpotifyLogo = createIcon({
	displayName: 'SpotifyLogo',
	viewBox: '0 0 24 24',
	path: (
		<g clipPath='url(#clip0)'>
			<path
				d='M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z'
				fill='#2EBD59'
			/>
		</g>
	)
});

export const F1Logo = createIcon({
	displayName: 'F1Logo',
	viewBox: '0 0 5120 1280',
	path: (
		<g width='5120' height='1280' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<image
				width='5120'
				height='1280'
				x='0'
				y='0'
				href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACgAAAAKACAYAAABQCyFnAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
				AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAB/
				rUlEQVR42uzde7TfeV3f++d3J5mBGZiZ7AyoCIpUq0LrDa0X0Cp38A5q8V6vqLWlF3WwQ3uStiqg
				trXVWq2XiiigVbwLKGq19vSsarWnPe2xpy2tVIrM7J0MKCrM5Hf+2N9hAkwmO5ns/fn99vfxWCsr
				mcwlr8xakMzOM+/PFAAAAFxlqzpxRz2o6liduGv+8p11zfG6vuquunZV11Vt1QNW9cD5yw9c1QOq
				prpuVdfO/8zrp7pm/vIDp/mvudtUx6sH38uck/ey70HViXf66mub97yTG/a+G/fbdfO3AQAAAMD9
				8ze365tGj1gHqzqxWy+f6tNHbwHg8K3qzDR6BAAAAAdrVdMdddNddf3xvdDuxjv3grYb7o7mpr0Y
				7kHtBXbXT3OQd0Fod920F+xdP9U1dwd0Uz14tffPuDuSu7HaGv19BgAAAODIEv/NxH8Ay7aqM6fq
				tAAQAABgzZytm87Xg87XdSf2ArsbVnuX8K6f6qb58+vau3Z3w6qu29q7qnfTau/zt/+5+cvXXfka
				AAAAAFgbX79dLxg9Yh2I/wCW7e74r0oACAAAcJW9rh74gDq5VSenvednT051clUPmOqB5y/4ut71
				00Pau6gHAAAAAMym+lsn6++N3rEOxH8AyzbV6ZN15oI/BgAA4N68vq57QN28VQ89Xw+Z6ubq1Grv
				84dOtX2+bprqpvbivZvmT57ABQAAAICrx+W/mfgPYNkuvPx3NwEgAACwGK+rBz643uN8PawLLvCt
				6j2av+6CTw9rL+YDAAAAAAZx+e8e4j+AZXvny38XfD0AAMDmWtU1u/XQ6hFb9dBVPWK198cPn+rd
				7v58/jr/DQQAAAAAm8Plv5n4D2DZ7u3y39384hcAALCWVnXN7XXziXsu9r3Hqh423XOt7+7PH1od
				G70XAAAAALh6XP67h/gPYNkudvnvgj8PAABw+N5Up+6q96re++5P5/c+f6+tvSt+7zZ6IwAAAAAw
				hMt/M/EfwLLd1+W/uwkAAQCAA3GuTlaPuqsetVUPW9V7TPWoVT2qet/qxtEbAQAAAID14vLfPcR/
				AMt2qct/F/x1AAAAl2+nbjhW73e+3m+q9z1f7zvdc9Hv4dU1ozcCAAAAABvF5b+Z+A9g2fZz+e9u
				AkAAAOCiVnXtHfWe5+sx1aOrR11wxe998t8UAAAAAMBV4PLfPcR/AMu238t/F/z1AADAkq3qmjvq
				4XfuPdX7qFU9ZqsePUd+j6y2Rm8EAAAAAI4u8d89xH8Ay3a58d/89wAAAEvw2nrAyb2w7zGr+jPt
				fXp0e8/2ivwAAAAAgBE8+zsT/wEs2+U8+3uh46OHAwAAV9eqjt9R73XBs72PqR5bvf/5OjZ6HwAA
				AABAvf3yn/gv8R/A0k11evsyL/9d8PcCAACb6rZ62FSPPrZ31e+x7QV/j64eOHobAAAAAMDFePb3
				HuI/gGW7kmd/L+QCIAAAbIBVnThXf+Z8PXaaP632Qr/r5z8PAAAAALApvt7lvz3iP4BlW9WZK738
				dzcXAAEAYM2s6vhuvf9WPfbu4K/6sFz1AwAAAAA2nMt/9xD/ASzb/b38d8E/BwAAGEXsBwAAAAAs
				hfjvHuI/gGW7WvHf/M8CAAAOw6qmnfqAY/VRq/rw9mK/D64eMHobAAAAAMAB+/ptz/5W4j+ApVvV
				mVN1+mr98wSAAABwQFZ1/I764FU9vnrcqj6+esjoXQAAAAAAh8nlv3uI/wCW7Wpe/rvgnwkAAFwN
				O3XDqv7cVI/f2gv+Hp/rfgAAAADAgon/7iH+A1i2g4j/5n8uAABwJW6rh23V46rHT3uff2i1NXoX
				AAAAAMA6EP/dQ/wHsGwHFf9VHR/9nQMAgE2wquls/dlVPXGqj1vVx0z10NG7AAAAAADW1NefrBeM
				HrEOxH8Ay7aqM9sHFP+VC4AAAHBRb6x3P1YfO9WTqmdUDx+9CQAAAABg3bn8dw/xH8CyHeTlvwu+
				DQAAoOqN9aCt+qitveDvSdWH5efMAAAAAAD7Jv67h/gPYNkOI/6bvx0AAFimVR2/oz74fD1pqiet
				6s9XJ0bvAgAAAADYROK/e4j/AJbtsOK/+dsCAIDl2K0PWtWT52d9P7a6fvQmAAAAAIAj4Ou36wWj
				R6wD8R/Asq3qzKk6fVjf3vHR32EAADhIqzp+tj6q+qSpPn1Vf9rvggEAAAAAuHrmy3/iv8R/AEs3
				1entQ7r8d8G3CQAAR8sdtX1nPXGqT64+pbpx9CYAAAAAgKPIs7/3EP8BLNthPvv7Tt8uAABsvnP1
				qNVe8PdJq/rz1YnRmwAAAAAAjrjnb9c3jB6xDsR/AMs2Kv6bv20AANg8qzp2tj66+qT2wr9Hj94E
				AAAAALAg4r+Z+A9g2UbGf/O3DwAAm+F19cAH1dNX9czq6dX26E0AAAAAAAv09dv1gtEj1oH4D2DZ
				VnXmVJ0eueH46H8JAABwX1Z1bKc+Yau+oPrUVd0wehMAAAAAwII9X/y3R/wHsGxTnd4eePnvgh0A
				ALBeVrV1tj5mVZ851WdXDxm9CQAAAAAAz/7eTfwHsGyjn/19py0AADDeO0V/n1W9++hNAAAAAAC8
				nfhvJv4DWLZ1iv/mPQAAMM5OPaa96O8LqvcZvQcAAAAAgHch/puJ/wCWbd3iv6rjowcAALA8u/Vn
				q8+t/kL1yNF7AAAAAAC4qK/frheMHrEOxH8Ay7aqM9trFv+VABAAgEOyWze2F/x9QfW40XsAAAAA
				ALik54v/9oj/AJZtqtPrGP/N2wAA4GCsautsfUz1+e1d/Lt+9CYAAAAAAPbFs78z8R/Asq3js7/v
				tA8AAK6unXr4tBf8fXn1qNF7AAAAAAC4LOK/mfgPYNnWPf6bNwIAwP23qmt361OmvSd+n14dG70J
				AAAAAIDLJv6bif8Alm0T4r95JwAAXLmdesy098Tvl1anRu8BAAAAAOCKif9m4j+AZduU+K/q+OgB
				AABsnjfWg47vRX9fVf2Z0XsAAAAAALjfvn67XjB6xDoQ/wEs26rObG9I/FcCQAAALsO5+lPn68va
				+7Q9eg8AAAAAAFfF88V/e8R/AMs21elNiv/mzQAAcHGrmnbqicfqy1f1zOrY6E0AAAAAAFw1nv2d
				if8Alm2Tnv19p90AAPCubqsHH6vPrp5bPXr0HgAAAAAArjrx30z8B7Bsmxr/zdsBAOAed9T73VVf
				Uj2numn0HgAAAAAADoT4byb+A1i2TY7/5v0AACzdqrZ26glbe9f+PjE/TwQAAAAAOMrEfzPxH8Cy
				bXr8N38fAABYqjfWg47Vl031V6pHjt4DAAAAAMCB+/rtesHoEetA/AewbKs6c6pOj95xfx0fPQAA
				gMP3prr5bfXVU311dWr0HgAAAAAADsXzxX97xH8AyzbV6e0Nv/x3wfcFAICleGO9+/H6q+2Ff9eP
				3gMAAAAAwKHx7O9M/AewbEfh2d93+v4AAHDU3VHve2f95ameU107eg8AAAAAAIdK/DcT/wEs21GL
				/+bvEwAAR9W5+rDzexf/Pqc6NnoPAAAAAACHTvw3E/8BLNtRjP/m7xcAAEfNbj2+uqX6pNFbAAAA
				AAAYRvw3E/8BLNtRjf+qjo8eAADA1bGqY2frs9oL/z549B4AAAAAAIb6+u16wegR60D8B7Bsqzqz
				fUTjv3IBEABg461qa7eeNdXfrd5/9B4AAAAAAIZz+W8m/gNYtqN8+e+C7yMAAJvq9nrSVr2o+tDR
				WwAAAAAAWAviv5n4D2DZlhD/zd9PAAA2ze31pKm+aaoPH70FAAAAAIC1If6bif8Alm0p8d/8fQUA
				YFPs1uOrv1f9+dFbAAAAAABYK+K/mfgPYNmWFP9VHR89AACAS9upj67+bvXE0VsAAAAAAFg74r+Z
				+A9g2ZYW/83fZwAA1tVufdBUz1/VZ47eAgAAAADAWhL/zcR/AMu2xPhv/n4DALBuduoxW/V/rOoz
				8nM2AAAAAADunfhvJv4DWLalxn/lCWAAgLWyUw+f9j5Y83mr2hq9BwAAAACAtfW87Xrh6BHrQPwH
				sGyrOrO90PivBIAAAGvhDXX9NfXV1fOrB43eAwAAAADAWnu++G+P+A9g2aY6veT4b/53AADAKKva
				Ord37e8F1XuM3gMAAAAAwNrz7O9M/AewbEt+9ved/j0AADDC7fWkrfqW6oNHbwEAAAAAYCOI/2bi
				P4BlE//dQwAIAHDIbq8POFZ/Z1WfOXoLAAAAAAAbQ/w3E/8BLJv47x0JAAEADsmb6ua31d+a6quq
				46P3AAAAAACwMcR/M/EfwLKJ/96VABAA4IC9rh54ff2V6m9WN4zeAwAAAADARhH/zcR/AMsm/rt3
				Ls8AAByQVU1n63Orb6weMXoPAAAAAAAb53nb9cLRI9aB+A9g2VZ1Zlv8d69cAAQAOAC31fsfr29f
				1ZNGbwEAAAAAYCO5/DcT/wEsm8t/900ACABwFb2hrj9RXzvV11fXjN4DAAAAAMBGEv/NxH8Ayyb+
				uzQBIADAVbJbn1x9e/Veo7cAAAAAALCxxH8z8R/Ason/9kcACABwP91R73dX/ePqqaO3AAAAAACw
				0cR/M/EfwLKJ//ZPAAgAcIVeVw+8rm6Z6nnVtaP3AAAAAACw0cR/M/EfwLKJ/y6PABAA4ArMz/3+
				o+qRo7cAAAAAALDxxH8z8R/Ason/Lp8AEADgMpyrR53fC/8+cfQWAAAAAACOBPHfTPwHsGzivytz
				fPQAAIBN8Np6wA31vPN1S/WA0XsAAAAAADgSnrddLxw9Yh2I/wCWbVVntsV/V0QACABwCTv1MVN9
				T/WBo7cAAAAAAHBkPF/8t0f8B7BsU50W/125rdEDAADW1evrut16wVS/mvgPAAAAAICrx7O/M/Ef
				wLJ59vf+m0YPAABYRzv11Km+q3rv0VsAAAAAADhSxH8z8R/Ason/rg4BIADABc7WTau9Jxe+LD9X
				AgAAAADg6hL/zcR/AMsm/rt6/KI2AMBstz65+s7qPUdvAQAAAADgyBH/zcR/AMsm/ru6BIAAwOL9
				fr3bNfXtq/qM0VsAAAAAADiSxH8z8R/Ason/rj4BIACwaDv1mdPe1b9To7cAAAAAAHAkif9m4j+A
				ZRP/HQwBIACwSGfrkav6ruopo7cAAAAAAHBkif9m4j+AZRP/HZyt0QMAAA7Tqqaz9ZdX9R8T/wEA
				AAAAcHCeJ/7bI/4DWLZVnRH/HRwXAAGAxXhjvfvx+t7qGaO3AAAAAABwpLn8NxP/ASyby38HzwVA
				AGARduozj9f/k/gPAAAAAICDJf6bif8Alk38dzhcAAQAjrTdurH69urzRm8BAAAAAODIE//NxH8A
				yyb+OzzHRw8AADgoO/Xk6vuqh4/eAgAAAADAkSf+m4n/AJZN/He4PAEMABw5r6sH7tYLpnpl4j8A
				AAAAAA6e+G8m/gNYNvHf4fMEMABwpNxeH7FVP1i9/+gtAAAAAAAsgvhvJv4DWDbx3xguAAIAR8Kq
				ju/WLVv164n/AAAAAAA4HOK/mfgPYNnEf+O4AAgAbLxz9ajz9eLqcaO3AAAAAACwGOK/mfgPYNnE
				f2O5AAgAbKxVTbv11efrPyT+AwAAAADg8DxP/LdH/AewbKs6I/4bywVAAGAjvaluvrO+r/rk0VsA
				AAAAAFgUl/9m4j+AZXP5bz0IAAGAjXO2/vyqfqh6z9FbAAAAAABYFPHfTPwHsGziv/XhCWAAYGOs
				6thOnV7VaxL/AQAAAABwuMR/M/EfwLKJ/9aLC4AAwEbYqYdPe1f/Pm70FgAAAAAAFkf8NxP/ASyb
				+G/9uAAIAKy9s/UpU/124j8AAAAAAA6f+G8m/gNYNvHfehIAAgBra1XX7tS3reonqlOj9wAAAAAA
				sDjiv5n4D2DZxH/ryxPAAMBaOluPXNVLq48avQUAAAAAgEUS/83EfwDLJv5bby4AAgBrZ6c+c7X3
				5K/4DwAAAACAEcR/M/EfwLKJ/9afABAAWBuvqwfu1LdN9SPVjaP3AAAAAACwSOK/mfgPYNnEf5vh
				+OgBAABVZ+tDqpev6k+P3gIAAAAAwGI9b7teOHrEOpjjv5eJ/wCWaVVntsV/G8EFQABguLP1+av6
				dfEfAAAAAAADPV/8t+eCy3/PHL0FgMM31elTdXr0DvZHAAgADLOqa3fq21b14uq60XsAAAAAAFgs
				z/7OPPsLsGye/d080+gBAMAy7dQjpvrR6iNHbwEAAAAAYNHEfzPxH8Cyif82kwuAAMCh261nTPXb
				if8AAAAAABhL/DcT/wEsm/hvcwkAAYBDs6ppt26pfrraHr0HAAAAAIBFE//NxH8Ayyb+22yeAAYA
				DsWb6tSd9UPVU0dvAQAAAABg8cR/M/EfwLKJ/zafABAAOHDn6rHn619Ujxy9BQAAAACAxRP/zcR/
				AMsm/jsaPAEMAByo3fry8/WvE/8BAAAAADCe+G8m/gNYNvHf0eECIABwIF5bD7ipvmNVXzx6CwAA
				AAAAJP57O/EfwLKJ/44WASAAcNXdUe93V/1Y9WdHbwEAAAAAgMR/byf+A1g28d/R4wlgAOCq2q1P
				vqt+I/EfAAAAAADr4Xnivz1z/Pcy8R/AMq3qjPjv6BEAAgBXxaqm3bql+onqhtF7AAAAAACgvct/
				Lxw9Yh1ccPnvmaO3AHD4pjp9qk6P3sHV5wlgAOB+e2M96ER9/6o+Y/QWAAAAAACYefZ35tlfgGXz
				7O/RJgAEAO6XnXrEVK+oHjt6CwAAAAAAzMR/M/EfwLKJ/44+TwADAFfsbH1c9RuJ/wAAAAAAWB/i
				v5n4D2DZxH/LIAAEAK7Ibn35qn5xqoeO3gIAAAAAADPx30z8B7Bs4r/lOD56AACwWVZ17W59Z/VF
				o7cAAAAAAMAFxH8z8R/Ason/lmUaPQAA2By31cOO1Y9XHzl6CwAAAAAAXED8NxP/ASyb+G95BIAA
				wL7s1EdP9WPVe4zeAgAAAAAAFxD/zcR/AMsm/lumrdEDAID1t1ufN9UvJf4DAAAAAGC9iP9m4j+A
				ZRP/LZcAEAC4qFUd360XVD9YPWD0HgAAAAAAuID4byb+A1g28d+yeQIYALhXd9T2XXtP/n786C0A
				AAAAAPBObtmuF40esQ7m+O9lUz1z9BYADt+qzpyq06N3MM7x0QMAgPVzR73vXfXT1QeM3gIAAAAA
				AO/k+eK/PS7/ASzbVKe3Xf5bPE8AAwDvYLcef1f968R/AAAAAACsH8/+zsR/AMvm2V/uJgAEAN5u
				p76kek31kNFbAAAAAADgnYj/ZuI/gGUT/3EhASAA0KqmnTo91fdU14zeAwAAAAAA70T8NxP/ASyb
				+I93No0eAACM9Ya6/pr6oepTR28BAAAAAIB7If6bif8Alk38x70RAALAgt1WDztWP1U9dvQWAAAA
				AAC4F+K/mfgPYNnEf1yMABAAFupsfchqL/57xOgtAAAAAABwL8R/M/EfwLKJ/7gvW6MHAACHb6ee
				tapfT/wHAAAAAMB6Ev/NxH8Ayyb+41IEgACwMGfruVP9SHXd6C0AAAAAAHAvxH8z8R/Ason/2A9P
				AAPAQqzqmt367qm+cPQWAAAAAAC4CPHfTPwHsGziP/ZLAAgAC/CmOnVn/Vj150dvAQAAAACAixD/
				zcR/AMsm/uNyCAAB4Ig7V39qVT+3qj89egsAAAAAAFyE+G8m/gNYNvEfl+vY6AEAwMHZqY+qXlO9
				1+gtAAAAAABwEeK/mfgPYNnEf1yJrdEDAICDcbaeOdUvVQ8ZvQUAAAAAAC5C/DcT/wEsm/iPKyUA
				BIAj6Gw9d1U/Wj1w9BYAAAAAALgI8d9M/AewbOI/7o9p9AAA4OpZ1bGz9Q+rrx69BQAAAAAA7oP4
				byb+A1g28R/3lwAQAI6I19d1D6iXVp8yegsAAAAAANwH8d9M/AewbOI/rgYBIAAcAW+qU3fWT1aP
				G70FAAAAAADug/hvJv4DWDbxH1eLABAANtwd9b531s9N9X6jtwAAAAAAwH0Q/83EfwDLJv7jatoa
				PQAAuHI79dF31f8p/gMAAAAAYM2J/2biP4BlE/9xtQkAAWBD7dSzpnpNdfPoLQAAAAAAcB/EfzPx
				H8Cyif84CAJAANhAZ+u5U/1I9cDRWwAAAAAA4D7cKv7bI/4DWDbxHwdlGj0AANi/VR07W99W/aXR
				WwAAAAAA4BJu3a5vHD1iHYj/AJZN/MdBEgACwIZ4fV33gHp59UmjtwAAAAAAwCXcsl0vGj1iHczx
				38umeuboLQAcvlWdOVWnR+/g6Do+egAAcGnn6uT5+unqcaO3AAAAAADAJdwq/tvj8h/Ask11etvl
				Pw6YC4AAsObO1nuv6pXVB4zeAgAAAAAAl+DZ35n4D2DZPPvLYdkaPQAAuLidesyqfi3xHwAAAAAA
				60/8NxP/ASyb+I/DJAAEgDW1Ux811b+sHjF6CwAAAAAAXIL4byb+A1g28R+HTQAIAGvobH3qVL9U
				nRq9BQAAAAAALkH8NxP/ASyb+I8RBIAAsGZ26otX9S+qB47eAgAAAAAAlyD+m4n/AJZN/McoAkAA
				WCO7dctU31sdH70FAAAAAAAuQfw3E/8BLJv4j5Gm0QMAgFrVsbP1HdVzRm8BAAAAAIB9EP/NxH8A
				yyb+YzTXhQBgsFVde65eUn3G6C0AAAAAALAP4r+Z+A9g2cR/rAMXAAFgoHN18nz9VPX40VsAAAAA
				AGAfxH8z8R/Ason/WBcuAALAILfVw87Xz1cfNHoLAAAAAADsg/hvJv4DWDbxH+vEBUAAGGCnHj3V
				K6tHjN4CAAAAAAD7IP6bif8Alk38x7rZGj0AAJZmtx431b9K/AcAAAAAwGa4Rfy3Z47/Xib+A1im
				VZ0R/7FuBIAAcIjO1RPbu/x3cvQWAAAAAADYh1u360WjR6yDCy7/PXP0FgAO31SnT9Xp0TvgnQkA
				AeCQ7NZnn6+frx40egsAAAAAAOyDZ39nnv0FWDbP/rLOBIAAcAh266uql1QnRm8BAAAAAIB9EP/N
				xH8Ayyb+Y90JAAHggO3WLdV35MddAAAAAAA2g/hvJv4DWDbxH5tgGj0AAI6qVU3n6ltW9ddHbwEA
				AAAAgH0S/83EfwDLJv5jUwgAAeAArOr4bn33VF80egsAAAAAAOyT+G8m/gNYNvEfm0QACABX2aqu
				3a2X+qAAAAAAAAAbRPw3E/8BLJv4j00jAASAq+hs3bSqn64eP3oLAAAAAADsk/hvJv4DWDbxH5vo
				+OgBAHBU/H6926peWX3I6C0AAAAAALBP4r+Z+A9g2cR/bCoBIABcBWfrkefr1dX7jd4CAAAAAAD7
				JP6bif8Alk38xybzBDAA3E879eipXlU9fPQWAAAAAADYJ/HfTPwHsGziPzbd1ugBALDJbq+PmOpf
				Jv4DAAAAAGBziP9m4j+AZRP/cRQIAAHgCp2rJ2zVa6qbR28BAAAAAIB9Ev/NxH8Ayyb+46gQAALA
				FdipzzxfP189ePQWAAAAAADYp1vEf3vm+O9l4j+AZVrVGfEfR4UAEAAu02593lQ/XF0zegsAAAAA
				AOzTrdv1otEj1sEFl/+eOXoLAIdvqtOn6vToHXC1CAAB4DLs1ldVP1AdH70FAAAAAAD2ybO/M8/+
				AiybZ385igSAALBPu3VL9R358RMAAAAAgM0h/puJ/wCWTfzHUTWNHgAA625V09l6YfW1o7cAAAAA
				AMBlEP/NxH8Ayyb+4ygTAALAfVjVtFv/cKq/MnoLAAAAAABcBvHfTPwHsGziP446ASAAXMSqju3W
				9071haO3AAAAAADAZRD/zcR/AMsm/mMJBIAAcC9Wde1u/fBUzxy9BQAAAAAALoP4byb+A1g28R9L
				IQAEgHfyhrr+2nrFqp48egsAAAAAAFwG8d9M/AewbOI/lkQACAAXOFs3repnq48ZvQUAAAAAAC6D
				+G8m/gNYNvEfSyMABIDZm+uhb6tXVR8yegsAAAAAAFwG8d9M/AewbOI/lujY6AEAsA5uq/dY1Wuq
				Dxq9BQAAAAAALoP4byb+A1g28R9LJQAEYPHO1ftM9cvV+4/eAgAAAAAAl0H8NxP/ASyb+I8lEwAC
				sGi31we2F/+99+gtAAAAAABwGcR/M/EfwLKJ/1g6ASAAi3WuPry9+O/dRm8BAAAAAIDL8HXb9cLR
				I9bBHP+9bKpnjt4CwOFb1Zlt8R8Ld3z0AAAY4Vw99ny9qtoevQUAAAAAAC7Drdv1zaNHrAOX/wCW
				barT4j9wARCABdqpj6l+obpp9BYAAAAAALgMnv2dif8Als2zv3CPafQAADhMu/W46ueqG0ZvAQAA
				AACAyyD+m4n/AJZN/AfvSAAIwGLs1uPbi/8ePHoLAAAAAABcBvHfTPwHsGziP3hXW6MHAMBh2K2P
				TfwHAAAAAMDmEf/NxH8Ayyb+g3snAATgyDtbH5f4DwAAAACAzSP+m4n/AJZN/AcXJwAE4Ejbqaes
				6pXVg0ZvAQAAAACAyyD+m4n/AJZN/Af3TQAIwJG1U0+d6ieqB47eAgAAAAAAl0H8NxP/ASyb+A8u
				bRo9AAAOwk49bapXVA8YvQUAAAAAAC6D+G8m/gNYNvEf7I8AEIAjZ7eeXv144j8AAAAAADaL+G8m
				/gNYNvEf7J8ngAE4UnbrE3P5DwAAAACAzSP+m4n/AJZN/AeXRwAIwJGxU89qL/67dvQWAAAAAAC4
				DOK/mfgPYNnEf3D5BIAAHAk79RlTvbQ6MXoLAAAAAABcBvHfTPwHsGziP7gyAkAANt5OfZb4DwAA
				AACADST+m4n/AJZN/AdXTgAIwEbbqb8w1Q9Vx0dvAQAAAACAyyD+m63q2Nl6sfgPYJnEf3D/TKMH
				AMCV2q1nVz+Y+A8AAAAAgM0i/pvN8d9L2vuYPwALI/6D+88FQAA20k59cS7/AQAAAACwecR/M/Ef
				wLKJ/+DqEAACsHF26kum+mf5cQwAAAAAgM0i/puJ/wCWTfwHV49wAoCNslNfOtV358cwAAAAAAA2
				i/hvJv4DWDbxH1xd4gkANsZufflU35UfvwAAAAAA2Cziv5n4D2DZxH9w9U2jBwDAfuzWc6rvzI9d
				AAAAAABsFvHfTPwHsGziPzgYLigBsPZ26q8l/gMAAAAAYPOI/2biP4BlE//BwRFSALDWduqvT/Wt
				o3cAAAAAAMBlEv/NxH8Ayyb+g4PlAiAAa2unvkb8BwAAAADABhL/zcR/AMsm/oODJwAEYC3t1tdN
				9c2jdwAAAAAAwGUS/83EfwDLJv6DwyEABGDt7NYt1QtH7wAAAAAAgMsk/puJ/wCWTfwHh0cACMBa
				2anT1QtG7wAAAAAAgMsk/puJ/wCWTfwHh2saPQAA7rZTZ6b626N3AAAAAADAZRL/zcR/AMsm/oPD
				JwAEYC3s1N+d6vmjdwAAAAAAwGUS/83EfwDLJv6DMQSAAAy3W99Q/c3ROwAAAAAA4DKJ/2biP4Bl
				E//BOMdHDwBguVY17dbfr/7q6C0AAAAAAHCZxH8z8R/Ason/YCwXAAEYYo7//sFUzx29BQAAAAAA
				LpP4byb+A1g28R+MJwAE4NCtajpb31b95dFbAAAAAADgMon/ZuI/gGUT/8F6EAACcKjm+O8fV39p
				9BYAAAAAALhM4r+Z+A9g2cR/sD4EgAAcmjn++/bqq0ZvAQAAAACAyyT+m4n/AJZN/AfrRQAIwKFY
				1dZufc9UXzR6CwAAAAAAXCbx30z8B7Bs4j9YPwJAAA7cqo7t1vdO9YWjtwAAAAAAwGUS/83EfwDL
				Jv6D9SQABOBAzR8M+L7qC0ZvAQAAAACAyyT+m4n/AJZN/AfrSwAIwIGZPxjwz6vPG70FAAAAAAAu
				k/hvJv4DWDbxH6w3ASAAB2L+YMAPVJ87egsAAAAAAFwm8d9M/AewbOI/WH8CQACuulWd2K2XTfXM
				0VsAAAAAAOAyif9m4j+AZRP/wWYQAAJwVa3qmjn++/TRWwAAAAAA4DKJ/2biP4BlE//B5hAAAnDV
				rOqas/Xy6tNGbwEAAAAAgMsk/puJ/wCWTfwHm0UACMBVMcd/P1p9yugtAAAAAABwmcR/M/EfwLKJ
				/2DzCAABuN9Wde0c/33y6C0AAAAAAHCZxH8z8R/Ason/YDMJAAG4X15XD7y+fqJ6yugtAAD7cEd1
				fv7yndWbL/hzb6n+5O4/WNUdW/Nfu6o7pwv+2vP1lumCv/ad/rnt4+sv5ezl/g2ruqt60yH9ewQA
				ADgSjtXuTfWa0TvWwapO7NbLpnrm6C0AHL5VnTlVp0fvAC7f8dEDANhcr6/rrq2fqp44egsAsPbu
				jtPeUv1xda7646n+qDq3qre1F9idby+aq3siuLsjujfPId5bztefbNUfb9Ufna+3btUftvcX3bl1
				Qah3tv7offa+PQAAAOAixH8Ayyb+g83mAiAAV+QNdf019TPVx4/eAgAcmLPtRXtvvvvzqd60qrPz
				Nbw3nb/nz72pOjftRXlvmepNd9YfH6s/uLH+YNoL/AAAAIA1I/4DWDbxH2w+ASAAl+2N9aDj9bPV
				x43eAgBc0h9Wu3d/mmp3VTvVzmr+uq3581Xtnq+zq3rTQ97xaVwAAADgCBL/ASyb+A+OBgEgAJfl
				tnrwsfq56vGjtwDAQv1xddtUb1jVG1d7X/79Vf3+VLet6o1TveGuuu3mveDvT0YPBgAAANaP+A9g
				2cR/cHQIAAHYt526YapXVh89egsAHEF/Ur2++r3qf017X37d+Xr9VL93rN741nqDy3wAAADA/SX+
				A1g28R8cLQJAAPZlt26sXlV95OgtALCBzrcX9r22+h+r+p9z4Pe/pvq9t9br361+f/RIAAAA4OgT
				/wEsm/gPjp7jowcAsP7O1k2rvct/4j8AuLiz1X+f6r+v9j7/3+fr9cfqv7+l/vPD6i2jBwIAAADL
				tqpjZ+vF4j+AZZrq9HadGb0DuLoEgADcpztq+656dfXY0VsAYA28ufov1e9M9f+er9/Zqt95W/23
				h9YfjB4HAAAAcDEu/wEs26rOiP/gaPIEMAAX9aY6dWf9QvWho7cAwCH7H9XvrObQb6t+5876nZv3
				nvEFAAAA2CjiP4Bl8+wvHG0uAAJwr95cD3lb/WL1QaO3AMABuvui33+a6jfvqv/nmvrtG+r20cMA
				AAAArgbP/gIsm2d/4egTAALwLt5cD31bvab6M6O3AMBVsqr+21T/vvq/q/8w1b+/sV477f05AAAA
				gCPH5T+AZfPsLyyDABCAdyD+A+CIODfVb5yvX5/qN0/Uv3lw3TZ6FAAAAMBhcfkPYNlc/oPlmEYP
				AGB9/H6924m9+O8xo7cAwGX4w+q3V/WbW/Wb5+s3t/ee9HXZDwAAAFikOf57SfXs0VsAOHxTnT4p
				/oPFcAEQgKpur/fc2ov/3n/0FgC4hJ3q16b6l1P96o31f0915+hRAAAAAOvAs78Ay+bZX1geASAA
				7dTDp/rl6n1HbwGAdzbV76/q31b/aqt+8cb6ranOj94FAAAAsG48+wuwbJ79hWUSAAIs3G69V/VL
				1Z8avQUAZrdXv7CqXz5fv/qQ+p3RgwAAAADWnct/AMvm8h8slwAQYMHEfwCsibuq365+8Xz94qn6
				FU/6AgAAAOyfy38Ay+byHyzbNHoAAGOcrfde7cV/jxq9BYDlWdUbt+pfVj+zVT9zY+2O3gQAAACw
				ieb47yXVs0dvAeDwTXX6pPgPFs0FQIAFOld/6vxe/Pdeo7cAsCj/bqpXVD99sv7vqVajBwEAAABs
				Ms/+AiybZ3+BcgEQYHHO1iNX9cvVI0dvAeDIO1/91qp+5nz98EPqv4weBAAAAHBUuPwHsGwu/wF3
				EwACLMgd9X537cV/7zl6CwBH1l3Vv5nqR++sH31IvX70IAAAAICjRvwHsGziP+BCngAGWIjb6v3v
				2nv292GjtwBw5NxVvWaqH6p+6mSdGz0IAAAA4Kjy7C/Asnn2F3hnAkCABbit3v+Y+A+Aq+8/repH
				t+qfn6z/MXoMAAAAwFE3X/57sfgPYJmmOi3+A96ZJ4ABjjjxHwBX2e+t6seO1Q/cVP9u9BgAAACA
				pfDsL8CyefYXuBgXAAGOsJ16zFa9ZlXvNnoLABvtj1b1I1t70d+/nOr86EEAAAAAS+LZX4Bl8+wv
				cF8EgABH1O31gVP9ovgPgCs11X9Z1fcdr++5oXZG7wEAAABYIs/+AiybZ3+BS/EEMMARdLY+eFW/
				UD1k9BYANs5bp/rJu+q7T9VrplqNHgQAAACwVJ79BVg2z/4C+yEABDhi5vjvF6ubR28BYKP81+p7
				TtT3PbhuGz0GAAAAYOnEfwDLJv4D9ssTwABHyNn60Pny36nRWwDYDFP9wvn61u16tWt/AAAAAOth
				VSd262We/QVYplWd8ewvsF8CQIAjQvwHwGV421Q/cVd98831b0ePAQAAAOAe8+W/F4v/AJZpqtPi
				P+ByCAABjoBz9WHn69WJ/wC4b29e1fdX37Jdrxs9BgAAAIB35NlfgGXz7C9wJabRAwC4f87txX+/
				UG2P3gLA2vqf1XdO9V0n69zoMQAAAAC8K/EfwLKJ/4Ar5QIgwAbbqY86X6+sbhy9BYC19F+n+oab
				6iVT3Tl6DAAAAAD3blUndutlnv0FWKZVnfHsL3ClBIAAG2qnPmaqn69uGL0FgLXz2uoFJ+v7hH8A
				AAAA622+/Pdi8R/AMk11WvwH3B+eAAbYQOI/AC5C+AcAAACwQTz7C7Bsnv0FrgYBIMCG2a3HtRf/
				PXj0FgDWhvAPAAAAYMOI/wCWTfwHXC2eAAbYIGfr41b1s9WDRm8BYC28bqq/dVO9ZKq7Ro8BAAAA
				YH9WdWK3XubZX4BlWtUZz/4CV4sLgAAbYrc+tvq5xH8A1B+s6lvfUi98RP3R6DEAAAAA7J/LfwDL
				5vIfcLW5AAiwAc7VE87XT1fXjd4CwFBvneo7jtU33FA7o8cAB29VW3fUjRd+3V31oGN14gr+WTdO
				tXU/99xwVx0b/e8FAADYLKfqV6d66+gd68DlP4Blc/kPOAgCQIA1d3s96Xz9ZOI/gCVbVS/fqr95
				U7129BhYd3dHc1u1dX6O587XdVt17Z17AdyNVcfq+vN1zbQXtN0w/73XT3VNF3xdF/w9F3jQdEGE
				t6oT07tear5h9Y6x3LW968/pTr7TH183/3VVnb2X79+09/250n8399v9KggBAIAl+rqpfnH0iHUg
				/gNYtlWdOVWnR+8Ajh5PAAOssZ16ylQ/UT1w9BYAhvmVrfram+o3Rg+Bq2VVJ+7Yi+VuOr8X4V1X
				3XBsL7i7flXXVzeu6oFTPaC9v/ZEddMc69242ov0rm/v50kPWN0T5N2U/9YFAABYF1+3Xd88esQ6
				EP8BLJv4DzhIflEEYE3t1NOmekV7v+gNwPL8r1X9jVP1I6OHwIVeX9edqJu26uS0F9u9w6dp76Ld
				3X9842ov3rt+/nRy/vya0d8PAAAADpz4byb+A1g28R9w0ASAAGtot55R/VjiP4Al+pPq77+1vuHd
				6w9Hj+HoWtXWH9SpP6mbt+rmqW4+v/f5Q6c6taqb2/vjU+1d6rtpDv7EewAAAFyK+G8m/gNYNvEf
				cBgEgABrZrc+qfoX1bWjtwBw6H7+WD33xvr/Rg9hM63q2O31bifqYefrPar3mOo9Vntffrf2or5T
				8+c3578JAQAAuPrEfzPxH8Cyif+Aw+IXewDWyNn6lFX9aC7rACzNa6f6ayfrJ0cPYX3dUdvn672q
				91rVe67q3bfqYXPc97Dq3duL/LZGbwUAAGCxxH8z8R/Ason/gMMkAARYE2fr01b18sR/AEvyJ1N9
				0x/Uix5RfzR6DOOsarq93mOrHjntRX7v3T2fP3L+8oNH7wQAAID7IP6bif8Alk38Bxw2ASDAGjhb
				z1zVy6oTo7cAcGh+/Xx96c31/44ewuFY1Ynb632O1fut6k9P9X7T3pcf2V7g5zcBAAAAsKnEfzPx
				H8Cyif+AEQSAAIPt1LOmemniP4CleEv1d07WN091fvQYrr5zdfJ8PaZ6dPWoqR61qke193UPGL0P
				AAAArrJbt+sbR49YB6s6drZeUj179BYADt9Up0/WmdE7gOURAAIMtFOfMdUPJ/4DWIqfq75yu353
				9BDuv3Nz6DfVY1d7sd9jqg+prh+9DQAAAA6J+G8m/gNYNvEfMJIAEGCQnfqsqX6oOj56CwAH7mz1
				vO367tFDuHy7deNWve+qHnO+HrtVjz5fHzTVQ0dvAwAAgIHEfzPxH8Cyif+A0QSAAAPs1udUL66O
				jd4CwIF7yfH6azfU7aOHcGk7dcPW3kW/D5/qI1b1EdUjR+8CAACANfN12/XNo0esg1Wd2K2XTfXM
				0VsAOHyrOnOqTo/eASybq1MAh2x373cA/kDiP4AjbVVv3KrnnKyfGL2Fezd/gP5PT/W46vHVY6sP
				WNXW/OcBAACAd3Wr+G/PfPnvxeI/gGWa6vS2y3/AGnABEOAQna0vWNX3Jf4DOOp+4kQ958H1xtFD
				uMdt9bBj9XHVx1YfU/2Z/KYoAAAAuBwu/81c/gNYNpf/gHXiF7sADsnZ+qJVfU/zVSEAjqQ3VV+7
				Xd89egh7wd9WPW6qJ7V34e8D85ugAAAA4Eq5/Ddz+Q9g2Vz+A9aNABDgEOzUl6z2YhDxH8ARtapf
				muqLtut3R29Zqp169FQf396Fv4+rHjZ6EwAAABwRLv/NXP4DWLZVnRH/AetGAAhwwHbqSybxH8BR
				9sft/W6/b57q/OgxS/KGuv6aekL1SdVTq/cevQkAAACOIJf/Zi7/ASyby3/AuhIAAhyg3XpO9Z15
				bhDgqPqt8/W5N9d/Hj1kCVa1dUd92KqettoL/j4q/00DAAAAB8nlv5nLfwDL5vIfsM4EKQAHZLe+
				svqO/H8twFG0qr79ZH3tVH8yesxRdrZuWtUnVk+vnlI9ZPQmAAAAWAjx30z8B7Bsqzpzqk6P3gFw
				Ma5lAByA+fKf+A/gaLpjVV92qn509JCj6k116q76xFV95mov+rtm9CYAAABYGM/+zjz7C7Bsnv0F
				NoEwBeAq262vqP5J/j8W4Cj6v7bqs2+q144ectTs1COmvSt/n1w9Lb9ZCQAAAEa5dbu+cfSIdTDH
				fy+pnj16CwCHb6rTJ8V/wAbwi2oAV9HZ+qur+vuJ/wCOmrtW9Y3b9XemunP0mKPiXD3qfH3WVM9c
				1Yfnx08AAAAYzbO/M8/+Aizbqs64/AdsCgEgwFWyU399Vd86egcAV9dUv3++vuBUvXr0lqNgt26c
				6lOrzz9fT6ym1ehRAAAAQHn29+08+wuwbJ79BTaNABDgKtitr61eNHoHAFfdq47X5z+4bhs9ZJOt
				6vjZekr1+dWnreoBozcBAAAA78Dlv5nLfwDL5vIfsIk8sQVwP+3U10w+MAJw1KyqF52sW6e6a/SY
				TbVTj5n2or8vrN599B4AAADgXt26Xd84esQ6mC//vaR69ugtABy+qU6fFP8BG8gFQID7Ybf+ZvUN
				o3cAcFXtVp+3XT8/esgmekNdf6I+Z6qvrD509B4AAADgPrn8N3P5D2DZXP4DNpkAEOAK7dYtif8A
				jprf2qrPuKn+++ghm+aOer+76kuqL6u2R+8BAAAALulW8d+e+fLfi8V/AMs01WnxH7DJPAEMcAXm
				+O8Fo3cAcFX94B/XVzys3jJ6yKZY1dZOPWGrnlt9Yv77AgAAADaFZ39nnv0FWDbP/gJHgV+gA7hM
				O/V3pvpbo3cAcNX80VR/6WR9/+ghm+KN9e4n6ktX9Zzq4aP3AAAAAJfFs78zz/4CLNuqzpyq06N3
				ANxfAkCAy7Bbf6+6dfQOAK6a/z7VZ5ys3xo9ZBPcUe97V31t9YXVtaP3AAAAAJdN/DcT/wEsm/gP
				OEqOjx4AsCl26u8m/gM4Sn7tRH3Gg+uNo4esu7P1wav6G3fVZ+e/IQAAAGBT3Sr+2zM/+/ti8R/A
				Mk11etuzv8AR4gIgwD64/Adw5Hz3yfrqqd42esg6263HV7dUn5j/dgAAAIBNdut2fePoEetgjv9e
				Uj179BYADt9Up0+K/4AjxvUOgEs4W9+yqr8xegcAV8VbV/VVp+p7Rw9ZV6va2q1nTvW86rGj9wAA
				AAD3m2d/Z579BVi2VZ1x+Q84ilzxALgPu/VN7QUQAGy+26f6zJP1K6OHrKvb60lb9S3VB4/eAgAA
				AFwVLv/NXP4DWDaX/4CjzAVAgHuxqmm3/kH13NFbALgqfnuqTztZ/3P0kHV0ez1pqm+a6sNHbwEA
				AACuGvHfTPwHsGziP+Co2xo9AGDdzPHfP5zEfwBHxcv/uB4n/ntXu/W43frlrfoF8R8AAAAcKeK/
				mfgPYNnEf8ASuAAIcIFVTWfr26f6qtFbALjfzle3nqwXTrUaPWad3F4feaz+3qqeNHoLAAAAcNV9
				3XZ98+gR62BVJ3brZVM9c/QWAA7fqs5si/+ABZhGDwBYF3P8953Vc0ZvAeB+e8uqvuBU/djoIevk
				tnr/Y/XC6lNHbwEAAAAOhPhvJv4DWLZVnTlVp0fvADgMLgACdM/lv8R/AEfB/z5fn3pz/dvRQ9bF
				2bppVc+r/mp17eg9AAAAwIG4Vfy3Z37298XiP4Blmuq0y3/AkrgACCzeHP99R/WVo7cAcL/9h6k+
				+WT9z9FD1sGqts7V552vb57qoaP3AAAAAAfm1u36xtEj1sEc/72kevboLQAcvqlOnxT/AQsjAAQW
				bVVbu/W9U/3F0VsAuN9etarPOlVvGj1kHZyrJ5yvf1B90OgtAAAAwIES/83EfwDLJv4DlkoACCzW
				qo7N8d8Xjt4CwP323SfrL0115+gho91R73u+vnFVnzl6CwAAAHDgxH8z8R/Ason/gCUTAAKLNH8g
				4J9Xnzd6CwD3y53Vc7frn4weMtrr6oHX1/Orr6muGb0HAAAAOHBft13fPHrEOljVid162VTPHL0F
				gMO3qjOn6vToHQCjCACBxZnjvxdXnzN6CwD3y5vmJ39fNXrIaDv15Km+s/pTo7cAAAAAh0L8NxP/
				ASyb+A+gjo8eAHCYLrj8J/4D2Gz/e6pP3K7fGj1kpDtq+676purL8pt7AAAAYCluFf/tufs3/Iv/
				AJZpqtPbnv0F8IuEwHLMHwj4gepzR28B4H75T9XTt+t3Rw8ZZVXTufr8VX1rdfPoPQAAAMChuXW7
				vnH0iHUwf8z/JdWzR28B4PBNdfqk+A+gEgACC+HZX4Aj418fr0+5oXZGDxnljnq/O+s7p3ri6C0A
				AADAoRL/zcR/AMsm/gN4R1ujBwActFWd2K0fSfwHsOlefrKesNT4b1XHz9bfvqv+o/gPAAAAFucW
				8d+eVZ04Vy9P/AewSKs6I/4DeEcuAAJH2qqu2a2XTfXpo7cAcOVW9Y+2669NdX70lhF26tHVD0z1
				4aO3AAAAAIfO5b+Zy38Ay+byH8C9cwEQOLJWdc3Zern4D2CjraqvO1XPXWL8t6ppt758qn8r/gMA
				AIBFEv/NxH8Ayyb+A7g4FwCBI2mO/36k+tTRWwC4Yn+yqi88tfeky+KcrUeu6vurjx+9BQAAABhC
				/DcT/wEsm/gP4L4dHz0A4Gpb1bVn68erZ4zeAsAVO1t98qn69dFDDtuqprP1nFV9c/Wg0XsAAACA
				IW7ZrheNHrEOVnXiXL20etboLQAcvlWd2Rb/AdwnFwCBI+W19YAb9+K/p4/eAsAV+73qadv1H0cP
				OWw79fCpvqd66ugtAAAAwDDiv9nd8d9K/AewSKs6c6pOj94BsO6OjR4AcLWs6tpV/YvqE0dvAeCK
				/beteuLJ+p3RQw7b2b1n63+++rOjtwAAAADD3LpdLxg9Yh3Mz/7+YPVZo7cAcPimOu3yH8D+bI0e
				AHA1zM/+/ovqk0ZvAeDKrOo3TtRH31T/bfSWw/TaesBOfduqXlGdGr0HAAAAGObW7frG0SPWwRz/
				vaR69ugtABy+qU6fFP8B7Nvx0QMA7q/X1QPP1U9WTx69BYArs6pfOl+f9uB68+gth+n2+oCtemn1
				IaO3AAAAAEOJ/2biP4BlE/8BXD4XAIGN9vq67kH1UyvxH8DGWtWPb9czHrKw+O9sfcFW/UbiPwAA
				AFg68d9M/AewbOI/gCszjR4AcKVeX9ddWz811RNHbwHgin37yXruVOdHDzksO3XDVN9Zfc7oLQAA
				AMBw4r+Z+A9g2cR/AFfOE8DARnpDXX9N/XT1CaO3AHBFVtXzl/YB7tvrI6e9J3/fZ/QWAAAAYLhb
				tutFo0esg1WdOLf3MZNnjd4CwOFb1Zlt8R/AFfMEMLBx5vjvZxL/AWyqu1b1nKXFf7v11Vv1q4n/
				AAAAAPHf290d/63EfwCLtKozp+r06B0Am8wFQGCjvL6umy//ffzoLQBckbeu6vNP1Y+MHnJYXlsP
				uKm+Y1VfPHoLAAAAsBZuFf/tmZ/9fXHiP4BFmuq0y38A9980egDAfnn2F2DjvWVVzzpVrxw95LDc
				Ue97V/1Y9UGjtwAAAABr4dalvYpwMXP895Lq2aO3AHD4pjp9UvwHcFUIAIGNcMGzvx8/egsAV+SO
				6pO261+NHnJYdusTqx+sTo7eAgAAAKwF8d9M/AewbOI/gKtra/QAgEuZ47+fTfwHsJFW9capPmEp
				8d+qpt26pfqpxH8AAADAHvHfTPwHsGziP4CrzwVAYK3N8d/PVR83egsAV+R376qnPKR+Z/SQw/Cm
				OnXn3gewnzZ6CwAAALA2xH8z8R/Ason/AA6GABBYW7t1Y/XK6qNGbwHgivzOqp58ql43eshhOFsf
				vKqfqB45egsAAACwNm7ZrheNHrEOVnXiXL10Vc8avQWAw7eqM6fq9OgdAEeRJ4CBtST+A9h4v3Wi
				Pm4p8d9uPWNVv5r4DwAAALjHreK/PfPlvxeL/wCWaarT4j+AgyMABNbO2bppqlcn/gPYVL9WfcKD
				642jhxy0VU27dWv109UNo/cAAAAAa+MWz/7umS//vTzP/gIs0qrOePYX4GAdHz0A4EJn66bqVav6
				c6O3AHBFfvnO+pSH1h+MHnLQVnXt2fru6gtGbwEAAADWist/s7sv/+XyH8AiTXV6W/wHcOCm0QMA
				7ib+A9h4P31Hfdb71B+PHnLQbquHHa9X+DELAAAAeCe3uvy3Z47/XpLLfwCLNNVpl/8ADocAEFgL
				c/z36lV9xOgtAFyRl56sL5zqbaOHHLSz9SGr+snqvUZvAQAAANaK+G8m/gNYNvEfwOHaGj0AQPwH
				sPG++2R93hLiv536rFX9euI/AAAA4B2J/2biP4BlE/8BHD4BIDDUm+rUqn5Z/Aewmab61pP1FVOd
				H73lIK1q2qnTU72sum70HgAAAGCt3CL+27OqE+fq5Yn/ABZpVWfEfwCH7/joAcBynauTd9arqg8Z
				vQWAK/LCk/W80SMO2qqOn63vmOrLR28BAAAA1s6t2/Wi0SPWwXz578XVs0ZvAeDwTXV6W/wHMMQ0
				egCwTG+uh7ytfrH6oNFbALhsq1V97an61tFDDtpt9eBj9SPV00ZvAQAAANaOZ39nnv0FWDbP/gKM
				JQAEDt0c/72m+rOjtwBw2VZTPfdk/ePRQw7a7fWeW/UzuVQLAAAAvCvx30z8B7Bs4j+A8QSAwKF6
				cz10vvwn/gPYPHdN9SUn6wdGDzlou3sXan+2evjoLQAAAMDaEf/NxH8Ayyb+A1gPx0cPAJZjjv9e
				U/2Z0VsAuGxvneqzT9aPjx5y0HbqKdWPVjeM3gIAAACsHfHfTPwHsGziP4D1sTV6ALAM4j+AjfaW
				VX3yQuK/L5n2nv0V/wEAAADvTPw3E/8BLJv4D2C9CACBA/fGeve31a8k/gPYRHdUTz1Vrx495CCt
				atqtb5rqe6oTo/cAAAAAa+cW8d+eVZ04Vy9P/AewSKs6I/4DWC+eAAYO1O/Xux3fu/z3gaO3AHDZ
				zp6vp99c/9foIQdp/h3r31l92egtAAAAwFq6dbteNHrEOpg/jvLi6lmjtwBw+KY6vS3+A1g7x0YP
				AI6u3693O1G/VD169BYALs9Uv1894VT9u9FbDtJr6wHn62VTfd7oLQAAAMBa8uzvzLO/AMvm2V+A
				9eUCIHAg3ljvPl/+E/8BbJ7f3aon3Vj/3+ghB+lcnTxfP1U9fvQWAAAAYC2J/2biP4BlE/8BrDcB
				IHDV7dTDp/rl6n1HbwHgsv3Oqp58Y71u9JCDdFs97Hz9fPVBo7cAAAAAa0n8NxP/ASyb+A9g/W2N
				HgAcLTv1CPEfwMb6T3ftPft7pOO/2+sDj9X/mfgPAAAAuHfPF//tEf8BLJv4D2AzTKMHAEfHBfHf
				nxq9BYDL9pvH62k31O2jhxyk2+vPbdXPVjeP3gIAAACspedv1zeMHrEOxH8Ayyb+A9gcLgACV4X4
				D2Cj/eqqnnDU47+devJWvSbxHwAAAHDvxH8z8R/Ason/ADaLABC4387We0/1LxP/AWyiV/5hPe1U
				vWn0kIN0tj5/qp+rHjR6CwAAALCWbhH/7VnViXP18sR/AIu0qjPiP4DNIgAE7pfdeq9V/VL1PqO3
				AHDZfuqO+vRH1B+NHnKQdusrVvXPq+OjtwAAAABr6fnb9aLRI9bBfPnvxat61ugtABy+qU6fqtOj
				dwBweabRA4DNdbbee7X37K/4D2Dz/PDJ+sKp7hw95CDt1i3VC0bvAAAAANaWZ39nnv0FWDbP/gJs
				LhcAgSsi/gPYaP/05N6TuEc6/tvZ+12K4j8AAADgYsR/M/EfwLKJ/wA2mwuAwGWb479fqR45egsA
				l+1FJ+t5U61GDzkoq5p26x9M9dzRWwAAAIC1Jf6bif8Alk38B7D5BIDAZTlbj5wv/z1y9BYALtsL
				t+t5o0ccpFUd263vmeovjt4CAAAArC3x30z8B7Bs4j+Ao0EACOzbHfV+d9UvVQ8fvQWAy7Ja1dec
				qr8/esiBfifr2t364ameOXoLAAAAsLbEfzPxH8Cyif8Ajg4BILAvc/z3y9V7jt4CwGW5a1Vfcaq+
				Z/SQg/SGuv7aesWqnjx6CwAAALC2xH8z8R/Ason/AI6W46MHAOvvtnr/+fLfw0ZvAeCyvK36glP1
				stFDDtK5Onm+fn5VHzl6CwAAALC2btmuF40esQ5WdeJcvbR61ugtABy+VZ3ZFv8BHCkCQOA+3VZ/
				+pj4D2ATvXWqZ5+sV4wecpDO1clVvar6iNFbAAAAgLX1fPHfnvny34sT/wEs0lSnxX8AR48AELio
				2+r9xX8AG+ktq/r07Xr16CEH6c310LfVL1QfNHoLAAAAsLY8+zvz7C/Asnn2F+DomkYPANaT+A9g
				Y/3hVn3KTXv/H35kvbHe/Xj9YvWY0VsAAACAtSX+m4n/AJZN/AdwtLkACLyL2+sDtvbCkfcYvQWA
				y3JuVU+/qf7N6CEHabfeq3pN9b6jtwAAAABrS/w3E/8BLJv4D+DocwEQeAfiP4DNtKo3btVTT9Zv
				j95ykM7WI1d78d+jRm8BAAAA1pb4byb+A1g28R/AMrgACLzd7fWBc/z37qO3AHBZ3jDVk0/Wfxw9
				5CDdVu+/2nv29+GjtwAAAABrS/w3E/8BLJv4D2A5XAAEqtqtD2ovqnjI6C0AXJbfPVZPvLH+6+gh
				B2mO1H+xetjoLQAAAMDaEv/NxH8Ayyb+A1iWrdEDgPHO1ge395yi+A9gs7x2qz7+qMd/Z+tDt+pX
				E/8BAAAAFyf+m4n/AJZN/AewPJ4AhoU7Wx8yP6d4avQWAC7L/3NXPXm7/vfoIQfpXH34+Xp1dXL0
				FgAAAGBt3bJdLxo9Yh2s6sS5emn1rNFbADh8qzqzLf4DWBwBICyY+A9gY/3WiXrqdt02eshBOlcf
				dr5elfgPAAAAuLjni//2zJf/Xpz4D2CRpjot/gNYJk8Aw0KdrQ8V/wFsnlX9xrF60oOPfvz32PP1
				C9X26C0AAADA2vLs78yzvwDL5tlfgGUTAMICzfHfLyT+A9g0v3q+nnBj7Y4ecpB26qPP1y8l/gMA
				AAAuTvw3E/8BLJv4DwABICzMufowl/8ANtIr/7Ce9pB68+ghB2mnPmaqV1Y3jN4CAAAArC3x30z8
				B7Bs4j8ASgAIi3KuPsxzigAb6WfuqE9/RP3R6CEHabceJ/4DAAAALkH8NxP/ASyb+A+Au02jBwCH
				41w99ny9OvEfwKZ52cn6gqneNnrIQdqtx1c/Vz149BYAAABgbYn/ZuI/gGUT/wFwIRcAYQHO7cV/
				Lv8BbJ6XnKzPF/8BAAAAiP/uJv4DWDbxHwDvTAAIR9xOffT5+qXq5OgtAFyW7zxZXzjVnaOHHKTd
				+tjq5xP/AQAAABcn/puJ/wCWTfwHwL0RAMIRtluPm+pV1Q2jtwBwWV64XV811fnRQw7SuXpC9crq
				QaO3AAAAAGvreeK/Pas6ca5envgPYJFWdUb8B8C9OT56AHAwdutxuagEsIleuF3PGz3ioJ2tjztf
				P1ldN3oLAAAAsLaev10vHD1iHcyX/15cPWv0FgAO31Snt8V/AFzENHoAcPWJ/wA20mpVX3uqvnX0
				kIN2tj5uVT+by38AAADAxXn2d+bZX4Bl8+wvAJciAIQjZrceX/1c4j+ATbKa6q+erH80eshBE/8B
				AAAA+yD+m4n/AJZN/AfAfggA4QjZrY9tL/4TVQBsjrum+rKT9f2jhxy0Of77uer60VsAAACAtSX+
				m4n/AJZN/AfAfh0fPQC4OsR/ABvpbav63O360dFDDpr4DwAAANgH8d9M/AewbOI/AC6HC4BwBHhO
				EWAjvXWqv3CyfmL0kIMm/gMAAAD2Qfw3E/8BLJv4D4DLdWz0AOD+Ef8BbKS3rOpTt/f+//tI26kn
				t/f9vG70FgAAAGBtif9m4j+AZRP/AXAlPAEMG2ynnryqn6weOHoLAPv2B1v1qTfVL40ectB26smT
				H6cAAACA+yb+m83x3w8m/gNYJPEfAFdKAAgbaqeeMu09GymqANgc51b19Jvq34wectDEfwAAAMA+
				iP9mF8R/nz16CwCHT/wHwP0xjR4AXL45/vvJ6gGjtwCwP6t641Y95WT9+9FbDpr4DwAAANgH8d9M
				/AewbOI/AO6vrdEDgMuzU08V/wFsnDdM9cSFxH9PEf8BAAAAlyD+m4n/AJZN/AfA1eACIGyQnXra
				VK9I/AewSf7nsXrSjfVfRw85aJ6nBwAAAPZB/DcT/wEsm/gPgKvFBUDYELv1dPEfwGaZ6r+s6mPF
				fwAAAACV+O/txH8Ayyb+A+BqcgEQNsBuPb368cR/AJvkP99VT3pIvX70kIN2wbO/fpwCAAAALkb8
				NxP/ASyb+A+Aq00ACGtut57RXvx37egtAOzbvzteT72hbh895KCJ/wAAAIB9EP/NxH8Ayyb+A+Ag
				eAIY1thufWLiP4CNMtW/PVZPFv8BAAAAVOK/txP/ASyb+A+AgyIAhDV1tj69ekXiP4BN8stvqyfc
				WLujhxy0nXqa+A8AAAC4hOeJ//as6sS5enniP4BFWtUZ8R8AB0UACGtop5612vtAwInRWwDYt1f+
				YX3iQ+sPRg85aDv11GkvUhf/AQAAABfz/O164egR62C+/PcDq3rW6C0AHL6pTp+q06N3AHB0CQBh
				zezUZ0z10sR/AJvkZ++oT39E/dHoIQdtjv9+IvEfAAAAcHGe/Z159hdg2Tz7C8BhmEYPAO4xx38/
				nPgPYJP8yMn6vKneNnrIQRP/AQAAAPsg/puJ/wCWTfwHwGFxARDWxE59pst/ABvnh0/W5y4k/nua
				+A8AAAC4BPHfTPwHsGziPwAOkwAQ1sBOfdZ8+e/46C0A7Ns/O1mfP9Wdo4cctDn+e0XiPwAAAODi
				xH8z8R/Ason/ADhsAkAYbI7/fijxH8Am+c6T9Zypzo8ectDEfwAAAMA+iP9m4j+AZRP/ATCCABAG
				2qm/IP4D2Dgv2q6vmmo1eshBE/8BAAAA+yD+m4n/AJZN/AfAKAJAGGS3nj3VSxL/AWySF27XLaNH
				HAbxHwAAALAP4r+Z+A9g2cR/AIwkAIQBduvZif8ANspUf3u7njd6x2EQ/wEAAAD7IP6bif8Alk38
				B8Bo0+gBsDRn64tW9T0JcAE2xWqqv36y/uHoIYdht55e/XjiPwAAAODixH8z8R/Ason/AFgHro/B
				IdqpL17VP0v8B7ApVtVfPlnfMXrIYRD/AQAAAPsg/puJ/wCWTfwHwLpwARAOyU598ST+A9gkd031
				pSfrn48echjEfwAAAMA+iP9m4j+AZRP/AbBOXACEQ7BTXzLVdyf+A9gUd1ZfdLJeMnrIYZjjv1dU
				147eAgAAAKwt8d9M/AewbOI/ANaNC4BwwHbqS6f6rsR/AJvirVM9++ReEHfkif8AAACAfRD/zcR/
				AMsm/gNgHbkACAdop75sqn+a+A9gU7xlVZ++Xa8ePeQwiP8AAACAfRD/zcR/AMsm/gNgXbkACAdE
				/Aewcf5wqz71pnrN6CGHQfwHAAAA7IP4byb+A1g28R8A68wFQDgAu/Xl7cV/IluAzXDHqp5xU/3r
				0UMOw249o/rxxH8AAADAxYn/ZuI/gGUT/wGw7lwmg6tst56T+A9gk5w9X089Jf4DAAAAuJv4byb+
				A1g28R8Am0CgBFfRbn1F9U/yvy2AjbCqN27VU07Wvx+95TCI/wAAAIB9EP/NxH8Ayyb+A2BTuAAI
				V8nZ+qvVdyb+A9gUb5jqieI/AAAAgLcT/83EfwDLJv4DYJMIleAq2Km/NtXfH70DgH373WP1xBvr
				v44echh26xOrH0v8BwAAAFyc+G8m/gNYNvEfAJvGBUC4n3bqr4v/ADbK/9iqTxD/AQAAALyd+G8m
				/gNYNvEfAJtIAAj3w079jam+dfQOAPbtd87X42+q/z56yGEQ/wEAAAD7IP6bif8Alk38B8CmEgDC
				Fdqpr5nqW0bvAGDf/tNd9Qk31++NHnIYxH8AAADAPoj/ZuI/gGUT/wGwyQSAcAV262un+ubROwDY
				t393vP78Q+p/jx5yGM7WM6tXJP4DAAAALk78NxP/ASyb+A+ATScAhMu0W19XvWj0DgD2Z1W/caye
				fEPdPnrLYThbz1zVy6oTo7cAAAAAa0v8NxP/ASyb+A+Ao0AACJdht26pXjh6BwD79mvn6wk31u7o
				IYdB/AcAAADsg/hvJv4DWDbxHwBHhQAQ9mmO/14wegcA+/Yrd9YzHlJvHj3kMIj/AAAAgH0Q/83E
				fwDLJv4D4CgRAMI+7NTpxH8Am+Rn76inP7T+YPSQw7BTzxL/AQAAAJcg/puJ/wCWTfwHwFEzjR4A
				626nzkz1t0fvAGB/pvrRm+pzp3rb6C2HYaeeNdVLE/8BAAAAFyf+m4n/AJZN/AfAUeQCINyHnfo7
				4j+AjfKym+pzxH8AAAAAbyf+m4n/AJZN/AfAUSUAhIuY47+/NXoHAPsz1fec3Lv8d+foLYdB/AcA
				AADsg/hvJv4DWDbxHwBHmQAQ7sVO/V3xH8BG+ac31XOmOj96yGHYqc8Q/wEAAACXIP6bif8Alk38
				B8BRJwCEd7Jbf2+q54/eAcC+ffN2feXC4r8fTvwHAAAAXJz4byb+A1g28R8ASyAAhAvs7n1A5NbR
				OwDYtxdu19eNHnFYxH8AAADAPoj/ZuI/gGUT/wGwFAJAmO3WN1Z/c/QOAPZnqv9ju543esdh8ewv
				AAAAsA/iv5n4D2DZxH8ALMnx0QNgHezWN7WgiARgw61W9Te26x+MHnJYLoj//NwNAAAAuBjx30z8
				B7Bs4j8AlmYaPQBGWtW0W/9gqueO3gLAvqyqv7Jd3z56yGER/wEAAAD7IP6bif8Alk38B8ASCQBZ
				rDn++4dT/ZXRWwDYl7um+rKT9f2jhxyWnfrMqX448R8AAABwceK/mfgPYNnEfwAslQCQRVrVdLa+
				rfrLo7cAsC93VX9xu14yeshhEf8BAAAA+yD+m4n/AJZN/AfAkgkAWZw5/vtH1VeP3gLAvrx1qs8+
				WT8+eshhEf8BAAAA+yD+m4n/AJZN/AfA0gkAWRTxH8DG+ZOpPutk/dToIYdF/AcAAADsg/hvJv4D
				WDbxHwAIAFmQOf77x9VfGr0FgH15y/n61JvrF0cPOSw79VlT/VDiPwAAAODixH8z8R/Ason/AGCP
				AJBFmOO/b6++avQWAPblD6b6lJP1y6OHHBbxHwAAALAP4r+Z+A9g2cR/AHAPASBH3hz/fUf1laO3
				ALAv587X026u/2v0kMMi/gMAAAD2Qfw3E/8BLJv4DwDekQCQI22O//5J9RWjtwCwL7dN9eST9e9H
				Dzks4j8AAABgH8R/M/EfwLKJ/wDgXfmFZo6sVW3t1vdO9RdHbwHg0qb6/dVe/PcfRm85LOI/AAAA
				YB/EfzPxH8Cyif8A4N75xWaOpDn++76pvnD0FgD25XVb9cQb6/8bPeSwiP8AAACAfRD/zcR/AMsm
				/gOAi9saPQCutlUdE/8BbJT/sVWfsLD47y+I/wAAAIBLEP/NxH8Ayyb+A4D75hedOVLmDwJ831Rf
				MHoLAPvyO6t60k31v0YPOSxz/PeS/DwMAAAAuDjx30z8B7Bs4j8AuDQXADky5g8CfH/iP4BN8Z/v
				qiecEv8BAAAAXEj8NxP/ASyb+A8A9mcaPQCuhvmDAP+8+rzRWwDYl986Xk+5oW4fPeSwiP8AAACA
				fRD/zcR/AMsm/gOA/XMBkI0n/gPYLKv6jWP1pCXFf7v1bPEfAAAAcAniv5n4D2DZxH8AcHkEgGy0
				+YMAP5D4D2BT/Fr1xBtrd/SQw7Jbz27vA9biPwAAAOBixH8z8R/Ason/AODyCQDZWPMHAV5cfe7o
				LQDsy6/cWc84VW8aPeSwiP8AAACAfRD/zcR/AMsm/gOAKyMAZCNd8EGAzxm9BYB9+fk/rGc8tP5g
				9JDDMsd/nv0FAAAA7ov4byb+A1g28R8AXLlp9AC4XKs6sVsvn+rTR28BYF9++mR95lR/MnrIYbkg
				/js2egsAAACwtsR/M/EfwLKJ/wDg/nEBkI2yqhNn60fEfwAb42Un65niPwAAAIB3IP6bif8Alk38
				BwD3nwCQjbGqa87Wj1SfNnoLAPvykpP1+VPdOXrIYdnd+0C1+A8AAAC4L+K/mfgPYNnEfwBwdQgA
				2QjiP4CN810n6wuXFP+drb+Y+A8AAAC4b+K/mfgPYNnEfwBw9QgAWXtz/Pej1aeO3gLApU31rSfr
				K6c6P3rLYTlbX7Sq783PrQAAAICLE//NxH8Ayyb+A4Cryy9Ss9YuiP8+ZfQWAPblhSfra6ZajR5y
				WOb473vy8yoAAADg4sR/M/EfwLKJ/wDg6vML1aytOf77F4n/ADbCVKe363mjdxwm8R8AAACwD+K/
				mfgPYNnEfwBwMI6PHgD3ZlXXzvHfJ43eAsAlrVb1Ndv190cPOUziPwAAAGAfxH8z8R/Ason/AODg
				TKMHwDsT/wFslNVUzz1Z/3j0kMMk/gMAAAAuZaq/dbL+3ugd60D8B7Bs4j8AOFjHRg+AC72uHni+
				fqp6+ugtAFzSXav6su36rtFDDtNOfXHiPwAAAOA+iP/uIf4DWDbxHwAcPE8AszZeVw98UP3Uqp40
				egsAl3Rn9QWn6qWjhxymnfqSqb478R8AAABwcV9/sl4wesQ6WNWJc3sfP3rW6C0AHL5VndkW/wHA
				gRMAshZeX9c9sH5S/AewEd461WefrB8fPeQw7dQXi/8AAACA+zJf/hP/9fbLfz+Q+A9gkaY6Lf4D
				gMMxjR4Ar6/rrq2fmuqJo7cAcEl/MtVfOFk/OXrIYZrjv3+W+A8AAAC4CM/+3sOzvwDL5tlfADhc
				LgAylPgPYKO8ZVWftl2/MHrIYRL/AQAAAJci/ruH+A9g2cR/AHD4XABkmDn+++mpnjB6CwCX9IdT
				ffLJ+uXRQw6T+A8AAAC4FPHfPcR/AMsm/gOAMVwAZAjxH8BGObeqp2/Xvxk95DDt1JdM9d2J/wAA
				AICLEP/dQ/wHsGziPwAYxwVADt3r67oH1M9UnzB6CwCXdPZ8PfXm+rejhxwm8R8AAABwKeK/e4j/
				AJZN/AcAYwkAOVTiP4DNMdXvr+rJ2/UfRm85TOI/AAAA4FLEf/cQ/wEsm/gPAMYTAHJo3lDXX1M/
				nfgPYBP871U96VT9p9FDDpP4DwAAALgU8d89xH8Ayyb+A4D1IADkUMzx389UHz96CwCX9D+36ok3
				1X8bPeQw7dSXTvVdif8AAACAixD/3UP8B7Bs4j8AWB9+gZsDJ/4D2BxT/ZdVfexN4j8AAACAdyD+
				u4f4D2DZxH8AsF6OjR7A0Sb+A9go/+9d9YSb6/dGDzlM4j8AAADgUsR/9xD/ASyb+A8A1o8ngDkw
				O3XDVD9ffczoLQBc0m+fqKc8uG4bPeQw7dZXVP8kPycCAAAALu7rt+sFo0esg1WdOFcvXdWzRm8B
				4PCt6sypOj16BwDwjo6PHsDR9Ia6fqqfTvwHsAl+83g99cG1M3rIYdqpL6u+I/EfAAAAcBHz5T/x
				X2+//PcDif8AFmmq09su/wHAWhIActXNl/9eVX3U6C0AXNKvr+oZN9SbRg85TDv1ZVP90zz7CwAA
				AFyEZ3/v4dlfgGXz7C8ArDe/6M1VtVs3iv8ANsav3VVPPyX+AwAAAHgH4r97iP8Alk38BwDrzy98
				c9Xs1o3VKxP/AWyCX7mznvGQevPoIYdpjv++Kz8HAgAAAC5C/HcP8R/Ason/AGAz+MVvroo5/nP5
				D2Az/Pwd9fSH1h+MHnKYLoj/ptFbAAAAgPUk/ruH+A9g2cR/ALA5/AI499sF8d9Hjt4CwCX9zMn6
				jKn+ZPSQwyT+AwAAAC5F/HcP8R/Ason/AGCzuADI/bJbN0716sR/AJvgR07WM5cW/+3Wl4v/AAAA
				gPsi/ruH+A9g2cR/ALB5BIBcsbN101SvXtWfG70FgEv64ZP1uVO9bfSQw7RbX17908R/AAAAwEWI
				/+4h/gNYNvEfAGwmASBX5GzdVL1K/AewEf7Zyfr8qe4cPeQwif8AAACASxH/3UP8B7Bs4j8A2FwC
				QC7bHP+5/AewGf7pyfqKqc6PHnKYxH8AAADApYj/7iH+A1g28R8AbDYBIJflgvjvI0ZvAeCSvmW7
				vnKB8d9zEv8BAAAA90H8dw/xH8Cyif+A/7+9O42ztCzMPHy/1d3u0HWqGiUYxiWJ0SRjNmcmi0uw
				BRF3REEkmahJ1OgYN6JJnKR71ESMxkSNicsYcQFcUFyiMSIQZeKMUSOJonEXFIGmlga7ge7qeudD
				ndYWupt+aznPOee5rk8I9da5z/lUVv1/zwOMPgEgh0z8BzBSzphKTi89YtD68d/fRPwHAAAAHID4
				7wfEfwB1E/8BwHhYX3oAo+HaZHoh+WiSny+9BYBb9MKp5CWlRwzaXPLMNvnLiP8AGG9zB/j3C0mu
				Kz0OAGAEvL6XnFF6xDBokw3zydlJHlN6CwCD1yZbp8R/ADAW/IGcW9SP/85P8nOltwBwUG2bnD6d
				vKL0kEET/wGwhq5vk+ua5Nok29tkvln637uTXNsme5rke22yu0l2tsmNTXJjm+xskt2Lyfcmkj17
				kmvXJ22S+STZnXxvw9L3SJK0yWKTbN/3hTcufY8bS38AAACMn73xXyv+A6hSm2ydTraU3gEArA5/
				JOegrk029eO/ny29BYCDapM8cyp5TekhgzaX/F6bvDJ+rgHgwG5Isq1Jvtsm29qlf74qS6fpbc9S
				3Lc38ru2SbZPJNsPW/rn3St5YQAAGDbiP4C6if8AYPz4QzkHJP4DGBmLbfLU6eQNpYcMmvgPoGpt
				ku8m+VaTXNEmVzZLcd/VTXJlm1y9J9mW5LtHuBoXAACSiP8Aaif+A4Dx5I/l7Nd1yRG7l+K/e5fe
				AsBB7WmSJ/WSt5QeMmjiP4AqzDfJV9rkq23ylYnk60kua5LLNiaXN8mu0gMBAGBUiP8A6ib+A4Dx
				tb70AIZPP/77WJL/XHoLAAe1u01+fSp5R+khgzaXPKtN/iLiP4Bx8e0kX2iSzy8mlyb50q2Srxy2
				dIIfAACwQuI/gLqJ/wBgvPmjOT/kuuSO/ZP/xH8Aw21Xk5zcS84rPWTQ+vHfK0vvAGBZFpJc2iaf
				aZJPJ7mkSb7QS+ZLDwMAgHEl/gOom/gPAMafEwD5vn7897EkP1N6CwAHdUOSx/SSD5UeMmgzybP7
				J/8BMBq+k+TiJvnnxeTTNyafOyrZWXoUAADUQvwHUDfxHwDUwQmAJPl+/HdBkp8uvQWAg9q5mDxy
				09JprVWZSZ7diP8AhlqbfKVJLmyWor+LJ5NvlN4EAAC1Ev8B1E38BwD1cAIg+578J/4DGG47JpJH
				TC0F21UR/wEMrR1N8sk2OX8xef+m5IulBwEAAEmbrJtLzoz4D6BKTbJlKtlaegcAMBgCwMpdldyp
				f/LfT5XeAsBBbW+Th0wmnyw9ZNBmkuc0yStK7wDg+77WJOe1yft6ySebZKH0IAAA4Af2nvwX8R9A
				ldpkq/gPAOriCuCKXZ0cuX4p/rtX6S0AHNTsRPLgyeTTpYcM2kzy3CZ5eekdAORzSd6d5H1TyedL
				jwEAAPbPtb8AdXPtLwDUyQmAlboqudP65PyI/wCG3bYmOXYyuaT0kEHrn/wn/gMo5/I2ee9E8uZe
				8q+lxwAAAAfn2l+Aurn2FwDqJQCs0LbkR9Ytnfx3z9JbADioK9tk81RyaekhgzaTPK9J/rz0DoAK
				fa9JzmmXor9/bpK29CAAAOCWufYXoG6u/QWAugkAK3NVcqd1Syf/if8Ahtt32+RB03XGf88R/wEM
				3KVJ3rIuecPGZLb0GAAA4NA5+Q+gbk7+AwAEgBXZlhzVP/nvJ0tvAeCgvjmRbJ5Mvl56yKA5+Q9g
				oHYneedi8lebkn8pPQYAAOjOyX8AdXPyHwCQCACrcXVy5LrkoxH/AQy7b04kD5xMvlF6yKDNJM8V
				/wEMxHVt8ndN8oqp5LLSYwAAgOVx8h9A3Zz8BwDsJQCswDXJndclF7TJPUpvAeCgvrQn2TyVXFF6
				yKDNJqcneVnpHQDjrEmuWlwKrd8wnVxbeg8AALB8/ZP/zkpyUuktAAyek/8AgH0JAMfc1cmRE8lH
				xX8AQ++Le5LNRyTfLT1k0GaS50b8B7CWtiV5xfXJq49KdpYeAwAArMw+J/+J/wAq5OQ/AOCmmtID
				WDszyY82yYVJfrz0FgAO6rPrk+MOT2ZKDxm02eT3k5xRegfAOGqSq5L82feS1x+dXF96DwAAsHJ7
				T/5rxX8AVWqTrdPJltI7AIDhIgAcU+I/gJHxmXXJcRuT2dJDBm0meW6TvLz0DoAxtDPJq9vkT131
				CwAA46N/8t9bkzy+9BYABq9JtvSc/AcA7IcrgMfQTHJ0k1wQ8R/AsLu4TR66scI4YyZ5XpP8eekd
				AGNmsUnOTXJ6L/lW6TEAAMDqEf8B1E38BwAcjABwzMwm/ylLJ//dvfQWAA6sTS7YnTziyGRH6S2D
				Npu8IMmfld4BMGY+keQZveTfSg8BAABW195rf+PaX4AqtcnWKfEfAHAQAsAxMpMcnaWT/8R/AMPt
				H3YmJx6dXF96yKDNJM+L+A9gNV3ZJM+fTN7aJG3pMQAAwOrqn/x3ZsR/AFVqki3iPwDgljSlB7A6
				5pK7tEsn/92t9BYADur9veRxTXJj6SGDNpv8QZI/Lb0DYEzsaZPXNMmfTCXbS48BAABW396T/1rx
				H0CV2mTrdLKl9A4AYPgJAMeAa38BRkOTvHsyObVJdpfeMmizyelJXlZ6B8CY+MJi8uRNyf8rPQQA
				AFgb/ZP/3prk8aW3ADB4TbKl5+Q/AOAQTZQewMqI/wBGxjmTyePFfwCswEKSM3rJL4r/AABgfIn/
				AOom/gMAulpfegDLN5fctU0uSnKX0lsAOLAmedNk8jtNsqf0lkGbTf4wyUtK7wAYA//aJE/sJZeU
				HgIAAKydvdf+xrW/AFVqk61T4j8AoCMnAI6oueQubXJBxH8Aw+71k8lvVxr/nR7xH8BKtW3yql7y
				S+I/AAAYb/2T/85sxX8AVWqSLdPJltI7AIDR05QeQHf9+O/CJHcrvQWAg3ptL3lGk7SlhwzabPL7
				Sc4ovQNgxF3WJL/RS/6p9BAAAGBtufYXoG6u/QUAVsIJgCNmPrl7m3w84j+AYffSqeTpNcZ/c8kL
				I/4DWKm3Jbm3+A8AAMZf/9rfcyL+A6hSm2wV/wEAK+EEwBHSP/nvoiR3Lb0FgIM6Yyp5QekRJTj5
				D2DFbmiSF/SSvyo9BAAAWHtO/gOom5P/AIDVsL70AA7NXHLX/rW/dy29BYADa5I/7iUvKr2jBPEf
				wIr9R5LH9ZJ/Kz0EAABYe+I/gLqJ/wCA1eIK4BEg/gMYCW2bPKfi+O/5Ef8BrMTbFpL7TIn/AACg
				CuI/gLqJ/wCA1eQK4CG3PfmJPckFSX609BYADqhtkt/rJa8uPaSEfvz30tI7AEbUQpIXTomoAQCg
				GuI/gLqJ/wCA1eYK4CHWj/8uTHLn0lsAOKDFNvntqeRNpYeUIP4DWJFtTXJyb+lnfgAAoALiP4C6
				if8AgLXgBMAhJf4DGAl7muTJveTM0kNKEP8BrMhnkpw4lVxWeggAADAY4j+Auon/AIC1MlF6ADe3
				LbnHnuSiiP8AhtnuNjml1vhvLvmTiP8AlqVJ/ncv+VXxHwAA1KNNNswn50T8B1ClNtkq/gMA1ooA
				cMhsS+6xbunkv6NKbwHggHY1ycnTybtLDylhJtnSJltK7wAYQW3/l72/1SQ3lh4DAAAMRv/kvzPb
				5KTSWwAYvCbZMu136gDAGnIF8BAR/wGMhBuTPHYq+UDpISXMJFuapdP/AOhmR5Oc1kvOKz0EAAAY
				HNf+AtTNtb8AwCAIAIfEtuQn1yUXRPwHMMx2LiaP3JScX3pICeI/gGW7YiJ5xGTymdJDAACAwRH/
				AdRN/AcADMr60gNIrknuNbEU/x1ZegsAB3RtkodtSj5RekgJM8nWJvnj0jsARtAle5ITppIrSg8B
				AAAGp002zCdnxbW/AFVqk61T4j8AYECcAFiYk/8ARsJ8mzxkOvm/pYeUIP4DWLZ/SvLIqWR76SEA
				AMDgOPkPoG5O/gMABm2i9ICaXZPcc11yYcR/AMNsbjF5sPgPgI7O25E8RPwHAAB1Ef8B1E38BwCU
				4ATAQq5J7tm/9vdHSm8BYP/a5OomOXYq+bfSW0oQ/wEsT5O8aTJ5SpMslN4CAAAMjvgPoG7iPwCg
				FCcAFiD+AxgJVzbJZvEfAB2d0UueLP4DAIC6iP8A6ib+AwBKcgLggPXjvwuTHFl6CwAHdPm6ZPPG
				5Culh5Qwk/yvJvmfpXcAjJg9SZ4+lbyu9BAAAGCwxH8AdRP/AQClrS89oCbXJPfqn/wn/gMYXt+a
				WIr/vlZ6SAniP4BlubFNTptO3l16CAAAMFjiP4C6if8AgGEgABwQ8R/A8GuSLy8mmyeTb5feUoL4
				D2BZ5pM8Yjr5ROkhAADAYIn/AOom/gMAhoUAcABmk3sn+ViSTaW3AHBAly4kDzoi+W7pISXMJi9J
				8oeldwCMmCuSPHgq+XzpIQAAwGC1yYb55KwkJ5XeAsDgtcnWKfEfADAkmtIDxt1c8rNtcn7EfwDD
				7JINybGHJdtKDylB/AewLJevW7oy/iulhwAAAIO1N/5rxX8AVWqTrdPJltI7AAD2cgLgGhL/AYyE
				z65PjjssmSk9pISZ5EUR/wF09a2Jpfjva6WHAAAAg9W/9vfMiP8AqtQkW5z8BwAMm4nSA8bVXPJz
				4j+A4dYmn16XHHt4xfFfk7yw9A6AEfPNieSYSfEfAABUpx//vTXJ40tvAWDwmmRLT/wHAAwhAeAa
				EP8BjIRPLCYP3JjMlh5SwmzyYvEfQGf/sZjcdzL5RukhAADAYIn/AOom/gMAhpkAcJXtE/9Nl94C
				wAH900JywhHJdaWHlDCbvDjJH5XeATBivrgnOWZT8p3SQwAAgMES/wHUTfwHAAw7AeAqEv8BjIQP
				70gecsfke6WHlDCbvCTiP4CuPrc+uf8RyXdLDwEAAAZL/AdQN/EfADAKBICrZC75efEfwND74Pbk
				xKOT60sPKaEf//1h6R0AI+az65MHHZ5cU3oIAAAwWOI/gLqJ/wCAUdGUHjAO+vHfRyP+Axhm7+wl
				pzXJ7tJDShD/AXTXJp9enzx4YzJbegsAADBY4j+Auon/AIBR4gTAFZpP7tMmF0T8BzDM3tpLTq01
				/ptLXh7xH0BXH19MHij+AwCA+rTJhvnknIj/AKrUJlvFfwDAKFlfesAom09+YTH5SJLJ0lsA2L8m
				eeNk8pQmWSy9pYTZ5E/b5LmldwCMmIsXkofeMfle6SEAAMBg9U/+OzPJSaW3ADB4TbJlSvy3KmaS
				45vkw6V3lNQmp08vHdJwQLPJHyV58Sq+7FOnkteVfu+HYj75scXkq6v4LV8ylbyw9PsCKMEJgMs0
				vxT/fTTJVOktABzQ307WHf/9WZI/KL0DYMRcvJA8RPwHAAD1ce0vQN1c+8uYGJmfY9oR2gow7ASA
				yzCf/KL4D2C4NckresnvVh7/vaD0DoARI/4DAIBKif8A6ib+Y4zcfy65a+kRh6JNTi69AWBcCAA7
				mhf/AYyCM3rJ85qkLT2khNnkpRH/AXQl/gMAgEqJ/wDqJv5jzDRt8rjSI27JNcm9kvxM6R0A40IA
				2MH8D+K/XuktABzQGVOVxm9t0swkf5nk+aW3AIwY8R8AAFRK/AdQN/EfY2rof65pklNLbwAYJwLA
				QzST/PJickHEfwBDq0n+Z83x32zyyib5vdJbAEaM+A8AACol/gOom/iPMfZzM8lPlx5xC1z/C7CK
				BICHYCb5lSb5hySHl94CwH61TfLsXvLi0kOKvPml+O8vxX8AnYn/AACgUuI/gLqJ/6jAKaUHHMh8
				cp8m+YnSOwDGiQDwFvTjvw9H/AcwrNokz+wtXX1bnX3iv2eW3gIwYsR/AABQKfEfQN3Ef9SgSU5t
				k6b0jv1ZdPofwKoTAB6Ek/8Aht6eJnnyVPKa0kNKaJNmLvkr8R9AZ+I/AAColPgPoG7iPypy99nk
				v5UecVP9KPGxpXcAjBsB4AHMJvftx3+Hld4CwH4tJDmtl/xd6SEl9OO/Vyf5H6W3AIyYi3Ylx4v/
				AACgPm2yYT45J+I/gCq1yVbxHzVpklNLb7ipueRXktyl9A6AcSMA3I/Z5FeTfCjiP4BhtatNTpla
				+oVtdfrx36uSPL30FoARc/FC8vAjkx2lhwAAAIPVP/nvzDY5qfQWAAavSbZMJ1tK74ABO6VN1pce
				cdNNpQcAjCMB4E30478PR/wHMKx2NcnJ08m5pYeUsE/894zSWwBGjGt/AQCgUq79Baiba3+p2BGz
				yebSI/Zql/qUx5TeATCOhq32LmouuX+b/H2SO5TeAsB+Xd8mj55KPlJ6SAn9+O+vkzyt9BaAEXPR
				ruRhTv4DAID69K/9PStO/gOoUptsnRL/FXFj8vHbJT+21q+zmHwpyYauz+1J7rkh2b3G22bW+v3f
				kv41wEPxd7Xtya8l+ZHSOwDGkQCwbza5r/gPYKjtXEweuSk5v/SQEvrx36sj/gPoyrW/AABQqb3X
				/kb8B1ClJtki/ivnqGRnkq+v9evMJu1yntuUfKNJdg38gxm8R1+ePPXo5PrSQ1qnMQOsGVcAJ5lN
				7pela3/FfwDDaUeTPEz8l6eX3gIwYlz7CwAAlXLtL0DdXPsL33fY7ZKHlR7RJhva5NGldwCMq+oD
				wH7896GI/wCG1fY2ObaXXFh6SAn9+O81Ef8BdCX+AwCASon/AOom/oMf1r8GuKi55Lgk06V3AIyr
				qgNA8R/A0JtbTI6bTj5ZekgJ+8R/v1t6C8CIEf8BAEClxH8AdRP/wX6dsD2ZKrzh5NIfAsA4qzYA
				nEvuH/EfwDDb1iTHbEo+VXpICeI/gGUT/wEAQKXEfwB1E//BAd1qITmx1It/I7lNkkeU/hAAxlmV
				AeB8srlNPhzxH8CwurJNfq2XXFJ6SAltMjGfvD7iP4CuLtqVHC/+AwCA+rTJhvnknIj/AKrUJlvF
				f1Tk203y5S4PlLwGeDI5IcnGDo98M8nXS+0FGEXVBYBzyQMWk/cluV3pLQDs15Vtsnk6ubT0kBL2
				nvzXJr9VegvAiLl4IXn4kcmO0kMAAIDB6p/8d2abnFR6CwCD1yRbppMtpXfAoDTJziydetzFA65J
				7lxo8ildvrhN3pbkukJbAUZSVQHgTHJs/+S/25feAsB+XbYuuV/l8d9fJ3la6S0AI8a1vwAAUCnX
				/gLUzbW/VOytSdoOXz/RJCcPeuSVye3bpRMAuzhn0DsBRl01AeBMclyzdPLfbUtvAWC/vjmRHLMx
				+WrpISX047/XRvwH0JX4DwAAKiX+A6ib+I+a9ZJvJfk/XZ4pcQ3wrZJHpdsBTZ+ZTr4w6J0Ao66K
				ALAf/50X8R/AUGqSL7fJ/SaTr5feUsI+8d9TS28BGDHiPwAAqJT4D6Bu4j9Ikry949f/4kzyUwPe
				2OnUwbb7ewIgFQSATv4DGHpfWkiOmU6+XXpICW0yMZu8KeI/gK7EfwAAUCnxH0DdxH+wZCJ5R5Ib
				Oz72uEHtm0smkxzX4ZE9e5KzB7UPYJyMdQA4kzy4H//dpvQWAPbr0oXkmCOSK0oPKWFv/Nckv1l6
				C8CIEf8BAEClxH8AdRP/wQ9MJnNJPtzlmSY5rU2aQexbTB6T5NYdHjn/jsmVg9gGMG7GNgDsx3/n
				RfwHMKw+uz55QK0/yO8T//330lsARoz4DwAAKiX+A6ib+A9ubhlX5v7YTHKfQWyb6Hj9b+P6X4Bl
				G8sAcCY5XvwHMLza5NPrkmMPT64pvaXQ+xf/ASyP+A8AACol/gOom/gP9u/a5INJ5rs80ySnrvWu
				65Ij2uSYDo/s3J28d613AYyrsQsA+/HfeyP+AxhWFyfZvDGZLT2khDZZJ/4DWBbxHwAAVEr8B1A3
				8R8c2N2SG5rk3C7PNMkpbbJuLXftTh6bZH2HR97rd78AyzdWAeBs8hDxH8BQ+/ie5ITp5NrSQ0ro
				/7Ja/AfQnfgPAAAqJf4DqJv4Dw5J16tzj5zpdjrfcnS6/ncZ7wGAfYxNADibPCTJeyL+AxhWH9mR
				HH9Ecl3pISXsjf+S/EbpLQAjRvwHAACVEv8B1E38B4dmMrkoyTe7PLNuDX++2pYcleS+h/r1bXJ1
				L/noWu0BqMFYBID9+M/JfwDD60Pbk0cdnVxfekgJ/V9W/13EfwBdif8AAKBS4j+Auon/4NA1SZvk
				HV2eaZOTLk9uuxZ7JpJT0q1FObtJFtbwIwIYeyMfAM4mJ2Qp/rt16S0A7NcHe8mJd0tuKD2khH3i
				v18vvQVgxIj/AACgUuI/gLqJ/6C7NnlLx0cOv8PSQUurbqLj9b+t638BVmykA8B+/PeeiP8AhtU7
				e8mJTXJj6SEl9H9Z/eaI/wC6Ev8BAEClxH8AdRP/wfJMJ5cmuaTjY6eu9o755O5t8l8O9evb5Cub
				kn9Z448HYOyNbAA4mzw04j+AYXZ2L3lCk+wuPaSEfeK/00pvARgx4j8AAKiU+A+gbuI/WLFOJ+m1
				yUPnksnVHLC4dP1vc6hfP7H0sx8AKzSSAWA//js34j+AodQkb+wlpzXJQuktJYj/AJZN/AcAAJUS
				/wHUTfwHK7dnKQDc0+GR2yR59CrP6HL9b9u4/hdgVYxcADiXnJjkvRH/AQyr100mT2mSxdJDShD/
				ASyb+A8AACol/gOom/gPVscRyRVtclHHx1bt569rknsmuXeHR/55Mvn6AD4agLE3UgHgTPKYNjkn
				yYbSWwDYr9f2kqdVHv+dGfEfQFfiPwAAqJT4D6Bu4j9YXRPdrwHevC05ajVeu+n+85zT/wBWycgE
				gDPJY5rk7Ij/AIbVy6aSpzdJW3pICfvEf08ovQVgxIj/AACgUuI/gLqJ/2D1LSbnJtnZ4ZGJ9clj
				V+O1m27fZ/f65F0D/XAAxthIBIAzyUniP4ChdsZU8vzSI0rp/7L6LRH/AXQl/gMAgEqJ/wDqJv6D
				tTGdXJvkAx0fO3Wlrzuf/EKSe3V45EOHJ9cM8KMBGGtDHwD247+zIv4DGEpN8sdTyQtK7yhln/hv
				xf/nCKAy4j8AAKiU+A+gbuI/WHNdrwH+r9uSe6zkBReTkzu+put/AVbRUAeAM8ljnfwHMLTaNnlO
				L3lR6SHFPoAf/LJa/AfQjfgPAAAqJf4DqJv4D9ZeL/lwm1zd5Zn1ySnLfb02aZI8rsMj1+5MPljq
				8wEYR0MbAPbjv7OSrC+9BYCbaZvkWdPJK0sPKfYB+GU1wHKJ/wAAoFJ+nwJQN/EfDEaTLDTJu7o8
				067g57PZ5JeS3LXDvncdnVxf7hMCGD9DGQDOJI8T/wEMrTbJM3rJq0oPKfgB+GU1wPKI/wAAoFJ+
				nwJQN/EfDNYyrti953zyC8t8uU7X/8b1vwCrbugCwH789/aI/wCG0Z4medJU8trSQ0ppkw2zyTvj
				l9UAXYn/AACgUuI/gLqJ/2DwppNPNsmXuzzTJqd2fZ02mWiSkzo88p3J5OOlPx+AcTNUAaD4D2Co
				7WmSJ/aSN5ceUko//ntHk5xYegvAiBH/AQBApcR/AHUT/0E5i8nZXb6+TR7fJuu6PDOfPCDJnTs8
				8rYm2VP6swEYN0MTAM4kJ4v/AIbWriZ5XG/pl7VV2if+e3TpLQAjRvwHAACVEv8B1E38B2WtT96W
				pO3wyFHzyf27vEbr+l+AoTAUAWA//ntbxH8Aw2hXk5zcS95TekgpbbJhLnmn+A+gM/EfAABUSvwH
				UDfxH5S3Mflqkk91eabt8LNbm6xvu/3t7JKp5N9Lfy4A46h4ADibnCL+AxhaNyY5qZecV3pIKXvj
				vySPKr0FYMSI/wAAoFLiP4C6if9geDTdT9w7qU1ufShfOJcc2yR37PC9nf4HsEaKBoCzySlZ+iWA
				+A9g+OxcTB42lXyg9JBS2uRW4j+AZRH/AQBApcR/AHUT/8FwWZ+ck2R3h0d688nxh/KFHa//XWyT
				s0t/HgDjqlgAOLv0f/6d/AcwnHY0ycM2JeeXHlJKP/57R8R/AF2J/wAAoFLiP4C6if9g+ByWbEvy
				j12eaZNTD+Frbt10+Btam1w4nXy79OcBMK6KBIBzyROzFP+tK/0BAHAz29vk2F5yYekhpTj5D2DZ
				xH8AAFAp8R9A3cR/MNS6Xr37iNlk48G+YD45IbfwNfuacP0vwJoaeAA4lzyxTd5Y4rUBuEVzi8lx
				08knSw8pZZ/475GltwCMGPEfAABUSvwHUDfxHwy3Hcl5SbZ3eOQ2zS38nazj9b83JHlv6c8BYJwN
				NMKbSZ4k/gMYWtua5JhNyadKDymlH/+9K+I/gK7EfwAAUCnxH0DdxH8w/I5Orm+XIsBD1h7kZ7sr
				ktsleWiHb/f+XjJf+nMAGGcDC/Fmkic1yRsG+ZoAHJomuSrJ5l5ySektpewT/z2i9BaAESP+AwCA
				Son/AOom/oOR0vUK3gddldxpf//hNkt/S7vDoX6jxvW/AGtuIDGe+A9gqF25mDxwKvn30kNKEf8B
				LJv4DwAAKiX+A6ib+A9Gy1TysSTf6fDI+g3JYw/w37pc/zs7mfxD6fcPMO7WPMibSZ4s/gMYWpet
				S+43nVxaekgp4j+AZRP/AQBApcR/AHUT/8HoaZLFJjmn42On3vRfzCSHJzm+w/c4p0l2lX7/AONu
				TaO8meS3muT1a/06ACzLNyeSYzYmXy09pJR+/PfuiP8AuhL/AQBApcR/AHUT/8FI63oV7y9vT358
				338xkZyY5DaH+g1a1/8CDMSahXn9+O91a/kaACxPk3y5Te43mXy99JZS9on/Hl56C8CIEf8BAECl
				xH8AdRP/wWjrJf+a5PNdntlzk+t+227X/35tKvlk6fcNUIM1ifNmkt8W/wEMrS8tJMdMJ98uPaSU
				fvx3bsR/AF2J/wAAoFLiP4C6if9gbJzV8eufsPcfrk02Jdl8qA+2ydubpC39hgFqsOqBXj/++9u1
				+N4ArNjnNiT3PyK5ovSQUtrk1v3472GltwCMGPEfAABUSvwHUDfxH4yVtydZ7PD195pLfjZJFpKT
				kmw41AcXu8eGACzTqkZ6Tv4DGGqfXZ886LBkW+khpfTjv3dH/AfQlfgPAAAqJf4DqJv4D8bLVHJZ
				kk90eaZNTu3/4yFf/9sknzoi+Y/S7xegFqsW6s0mv9OP/5rSbwqAH9Ymn16XHHt4MlN6S8HPwMl/
				AMsj/gMAgEqJ/wDqJv6D8dQunQLYxeOvSe6c5H4dnun6GgCswKoEgLPJM7J07a/4D2D4fGIxeeDG
				ZLb0kFIuT247l7w/yUNLbwEYMRftSo4X/wEAQH3aZMN8ck7EfwBVapOt4j8YTxPJu5Lc0OGRoyeW
				DoNad4hfv7B+6edIAAZkxQHgbPKUJK+K+A9gGH18ITnhiOS60kNKuTy57R2S9yU5rvQWgBFz8ULy
				8COTHaWHAAAAg9U/+e/MNjmp9BYABq9JtkwnW0rvANZGL5lvkr/v+FiXQzb+8bDk6tLvE6AmKwoA
				Z5OnJvmbiP8AhtFHdlR+alM//nt/mxxbegvAiHHtLwAAVMq1vwB1c+0vVGMtr+h1/S/AgC07AJxL
				npXktRH/AQyjD21PHnV0cn3pIaXsE/89qPQWgBEj/gMAgEqJ/wDqJv6DekwunQA4swbfesdC8v7S
				7w+gNssKAOeSZ7XJKyP+AxhGH+glJ94tuaH0kFKuSG4n/gNYFvEfAABUSvwHUDfxH9SlSXYlefca
				fOtz/X4ZYPA6B4AzybP78R8Aw+edveQxTXJj6SGlXJHc7tbiP4DlEP8BAEClxH8AdRP/QbVW/are
				1vW/AEV0CgBnkmc3yV+UHg3Afp3dS57QJLtLDyllb/zXJJtLbwEYMeI/AAColPgPoG7iP6hXL7k4
				yTdW6/s1yVVTyQWl3xdAjQ45AJxJniP+AxhOTfLGXnJakyyU3lJKP/77gPgPoDPxHwAAVEr8B1A3
				8R/UrUnaJGet4rd8e81/qwQo6ZACwJnkuU3yitJjAdiv100mT2mSxdJDStkn/ntg6S0AI0b8BwAA
				lRL/AdRN/AckyWLyttX6Xo3rfwGKucUAsB//vbz0UABurkn+opc8Tfwn/gNYBvEfAABUSvwHUDfx
				H7DXpuRLST6zCt/qi5PJZ0u/H4BaHTQAnEmeJ/4DGFov6y1F2m3pIaWI/wCWTfwHAACVEv8B1E38
				B9xUuzon963aSYIAdHfAALAf//156YEA7NcZU8nzS48o6YrkdrdJPij+A+hM/AcAAJUS/wHUTfwH
				7M+tlgLAhRV8i3YiObv0+wCo2X4DwNnkdPEfwHBqkj+eSl5QekdJe+O/JMeU3gIwYsR/AABQKfEf
				QN3Ef8CBHJZcneRjK/gWn5hMvlH6fQDU7GYB4GxyepKXlR4GwM20bfKcXvKi0kNKujK5vfgPYFnE
				fwAAUCnxH0DdxH/ALWlWdg3walwhDMAK/FAAOJv8fsR/AMOobZJnTSevLD2kpCuT299K/AewHOI/
				AAColPgPoG7iP+BQ3Ji8J8v7/fGu9cm5pfcD1O77AeBs8vwkZ5QeBMDNtEme0UteVXpISfvEf79W
				egvAiBH/AQBApcR/AHUT/wGH6shkR5L3dX2uTT54eDJTej9A7SaS78d/Ly09BoCb2dMkT5pKXlt6
				SEniP4BlE/8BAEClxH8AdRP/AcvQ+SrfCdf/AgyFCfEfwNDak+Q3e8mbSw8pSfwHsGziPwAAqJT4
				D6Bu4j9gOXrJR5Nc2eGR7fPJh0rvBiD5/8+wbXHITuaiAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIz
				LTExLTIwVDE1OjQ5OjAzKzAxOjAwFuWXvgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0xMS0yMFQx
				NTo0OTowMyswMTowMGe4LwIAAAAASUVORK5CYII=" />
		</g>
	)
});

export const SupportIcon = createIcon({
	// Doesn't display the full icon without w and h being specified
	displayName: 'BuildIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z'
		/>
	)
});

export const StatsIcon = createIcon({
	displayName: 'StatsIcon',
	viewBox: '0 0 24 24',
	path: (
		<path
			fill='currentColor'
			d='M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z'
		/>
	)
});

export const WalletIcon = createIcon({
	displayName: 'WalletIcon',
	viewBox: '0 0 24 24',
	path: (
		<g>
			<path
				fill='currentColor'
				d='M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z'
			/>
			<path
				fill='currentColor'
				d='M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z'
			/>
		</g>
	)
});

export const VisaIcon = createIcon({
	displayName: 'VisaIcon',
	viewBox: '0 0 24 24',
	path: (
		<svg width='26' height='20' viewBox='0 0 30 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z'
				fill='currentColor'
			/>
		</svg>
	)
});

export const BitcoinLogo = createIcon({
	displayName: 'BitcoinLogo',
	viewBox: '0 0 67 14',
	path: (
		<svg width='67' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M13.779 8.694A6.993 6.993 0 1 1 .209 5.308a6.992 6.992 0 1 1 13.57 3.386Z' fill='#F7931A' />
			<path
				d='M10.078 6.004c.14-.932-.57-1.433-1.539-1.767l.315-1.261-.768-.192-.306 1.229c-.202-.05-.409-.098-.615-.145l.309-1.237-.768-.191-.314 1.26a25.67 25.67 0 0 1-.49-.115v-.004l-1.058-.264-.204.82s.57.13.558.139c.31.077.367.283.357.446L5.197 6.16c.021.005.05.013.08.025l-.081-.02-.502 2.014c-.038.094-.135.236-.352.182.008.011-.558-.14-.558-.14l-.38.88.998.249.547.141-.317 1.276.766.192.315-1.263c.21.057.412.11.611.16l-.313 1.256.767.191.318-1.274c1.309.248 2.293.148 2.707-1.036.334-.954-.016-1.504-.705-1.863.501-.116.88-.446.98-1.127Zm-1.754 2.46c-.237.954-1.842.438-2.362.31l.422-1.692c.52.13 2.188.388 1.94 1.382Zm.238-2.474c-.217.867-1.552.427-1.986.318l.383-1.533c.433.108 1.828.31 1.603 1.215Zm11.936-1.754c.568 0 1.058.102 1.47.302.413.201.755.473 1.029.815.27.343.471.744.6 1.204.13.462.195.958.195 1.489 0 .815-.15 1.586-.451 2.312a5.995 5.995 0 0 1-1.23 1.896 5.786 5.786 0 0 1-1.842 1.274 5.617 5.617 0 0 1-2.3.47c-.107 0-.295-.003-.56-.008a8.166 8.166 0 0 1-.91-.08 10.687 10.687 0 0 1-1.09-.213 5.458 5.458 0 0 1-1.089-.39L17.383.428l2.744-.425-1.097 4.57a4.19 4.19 0 0 1 .707-.247c.237-.06.49-.09.761-.09Zm-2.3 7.584c.412 0 .802-.101 1.167-.301.367-.2.684-.47.949-.806a4.07 4.07 0 0 0 .628-1.143 3.9 3.9 0 0 0 .23-1.33c0-.567-.094-1.009-.283-1.329-.189-.318-.538-.478-1.045-.478-.166 0-.38.032-.645.088a1.61 1.61 0 0 0-.718.373l-1.168 4.854c.07.012.133.024.186.035a1.918 1.918 0 0 0 .38.037h.318Zm8.439 1.932h-2.62l2.212-9.318h2.638l-2.23 9.317Zm1.275-10.454c-.366 0-.698-.109-.992-.327-.297-.217-.443-.551-.443-1.001 0-.248.05-.48.15-.7A1.87 1.87 0 0 1 27.6.323c.219-.094.452-.14.7-.14.366 0 .695.108.99.326.295.22.443.554.443 1.002 0 .248-.05.481-.15.7a1.844 1.844 0 0 1-.974.947c-.219.096-.45.141-.698.141Zm3.252-1.186 2.744-.425-.674 2.746h2.94l-.531 2.16H32.72l-.778 3.26a3.69 3.69 0 0 0-.124.761c-.013.237.017.44.088.612a.77.77 0 0 0 .38.398c.184.095.445.143.788.143.283 0 .558-.027.825-.08.264-.053.533-.126.804-.222l.196 2.02c-.355.13-.738.242-1.151.337a6.62 6.62 0 0 1-1.47.14c-.814 0-1.445-.12-1.895-.361-.449-.243-.766-.574-.956-.994-.187-.418-.271-.9-.248-1.442a9.351 9.351 0 0 1 .248-1.72l1.736-7.333Zm4.894 7.918c0-.802.13-1.559.39-2.267A5.58 5.58 0 0 1 37.563 5.9a5.215 5.215 0 0 1 1.762-1.257c.689-.306 1.46-.46 2.31-.46.531 0 1.006.05 1.424.15.42.102.8.234 1.143.399l-.904 2.056a8.454 8.454 0 0 0-.734-.257 3.194 3.194 0 0 0-.93-.116c-.874 0-1.566.302-2.08.903-.513.602-.77 1.412-.77 2.428 0 .602.129 1.09.39 1.462.259.372.738.558 1.433.558a4.841 4.841 0 0 0 1.842-.372l.196 2.108a9.48 9.48 0 0 1-1.098.347c-.402.098-.88.149-1.435.149-.732 0-1.352-.107-1.859-.319a3.54 3.54 0 0 1-1.256-.859 3.24 3.24 0 0 1-.717-1.268 5.205 5.205 0 0 1-.223-1.522Zm11.641 3.969c-.626 0-1.17-.096-1.63-.284a3.009 3.009 0 0 1-1.141-.797 3.443 3.443 0 0 1-.682-1.214 4.903 4.903 0 0 1-.229-1.548c0-.71.114-1.42.345-2.128a6.032 6.032 0 0 1 1.018-1.912 5.441 5.441 0 0 1 1.646-1.393c.648-.359 1.392-.54 2.23-.54.613 0 1.154.096 1.62.285a3.03 3.03 0 0 1 1.152.797c.299.343.527.746.68 1.214.154.465.23.983.23 1.55a7.06 7.06 0 0 1-.336 2.126 6.143 6.143 0 0 1-.991 1.913 5.198 5.198 0 0 1-1.637 1.39c-.655.36-1.414.54-2.275.54Zm1.31-7.582c-.39 0-.733.112-1.027.335a2.894 2.894 0 0 0-.743.851 4.202 4.202 0 0 0-.453 1.125 4.87 4.87 0 0 0-.149 1.16c0 .591.095 1.052.283 1.383.19.33.53.496 1.027.496.39 0 .731-.112 1.027-.337.293-.224.542-.508.743-.85.2-.342.352-.718.453-1.126.099-.406.15-.794.15-1.16 0-.59-.096-1.051-.285-1.382-.189-.33-.531-.495-1.027-.495Zm6.784 7.335h-2.622l2.212-9.318h2.64l-2.23 9.317Zm1.273-10.454c-.365 0-.697-.109-.99-.327-.296-.217-.444-.551-.444-1.001 0-.248.051-.48.151-.7.1-.218.233-.406.399-.566.164-.16.358-.286.575-.382.218-.094.45-.14.698-.14.367 0 .698.108.992.326.295.22.444.554.444 1.002 0 .248-.053.481-.152.7a1.837 1.837 0 0 1-.972.947 1.73 1.73 0 0 1-.7.141Zm2.845 1.559c.2-.058.422-.128.663-.204a9.764 9.764 0 0 1 1.824-.371c.372-.043.795-.063 1.265-.063 1.382 0 2.335.402 2.86 1.205.526.804.617 1.902.276 3.295l-1.205 5.032h-2.638l1.168-4.926c.072-.307.127-.604.169-.895a2.12 2.12 0 0 0-.01-.761.911.911 0 0 0-.326-.532c-.173-.136-.434-.204-.789-.204a5.32 5.32 0 0 0-1.044.108l-1.717 7.21h-2.639l2.143-8.894Z'
				fill='#fff'
			/>
		</svg>
	)
});

export const EthereumLogoOutline = createIcon({
	displayName: 'EthereumLogoOutline',
	viewBox: '0 0 82 82',
	path: (
		<svg width='82' height='82' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M41 82c22.644 0 41-18.356 41-41S63.644 0 41 0 0 18.356 0 41s18.356 41 41 41Zm-.1-33.852-12.625-7.146 12.627 17.054L53.54 41.002 40.9 48.148Zm-12.436-9.44 12.632-20.082 12.628 20.088-12.63 7.147-12.63-7.154Z'
				fill='currentColor'
			/>
		</svg>
	)
});

export const DashCurveUp = createIcon({
	displayName: 'DashCurveUp',
	viewBox: '0 0 134 22',
	path: (
		<g width='134' height='22' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1 21v0C41.269-4.626 92.731-4.626 133 21v0'
				stroke='currentColor'
				strokeWidth='2'
				stroke-linecap='round'
				stroke-linejoin='round'
				stroke-dasharray='6 6'
			/>
		</g>
	)
});
export const DashCurveDown = createIcon({
	displayName: 'DashCurveDown',
	viewBox: '0 0 134 22',
	path: (
		<g width='134' height='22' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1 1v0c40.269 25.626 91.731 25.626 132 0v0'
				stroke='currentColor'
				strokeWidth='2'
				stroke-linecap='round'
				stroke-linejoin='round'
				stroke-dasharray='6 6'
			/>
		</g>
	)
});

export const ButtonLeft = createIcon({
	displayName: 'ButtonLeft',
	viewBox: '0 0 44 29',
	path: (
		<g width='44' height='29' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1 9.024A5 5 0 0 1 5.606 4.04l32-2.531A5 5 0 0 1 43 6.493v16.014a5 5 0 0 1-5.394 4.984l-32-2.53A5 5 0 0 1 1 19.975V9.024Z'
				stroke='currentColor'
				strokeWidth='2'
			/>
		</g>
	)
});

export const ButtonRight = createIcon({
	displayName: 'ButtonRight',
	viewBox: '0 0 44 29',
	path: (
		<svg width='44' height='29' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M43 9.024a5 5 0 0 0-4.606-4.984l-32-2.531A5 5 0 0 0 1 6.493v16.014a5 5 0 0 0 5.394 4.984l32-2.53A5 5 0 0 0 43 19.975V9.024Z'
				stroke='currentColor'
				strokeWidth='2'
			/>
		</svg>
	)
});

export const Fingerprint = createIcon({
	displayName: 'ButtonRight',
	viewBox: '0 0 48 48',
	path: (
		<g xmlns='http://www.w3.org/2000/svg' height='48' width='48'>
			<path
				fill='currentColor'
				d='M24.15 3.7Q27.45 3.7 30.625 4.5Q33.8 5.3 36.7 6.8Q37.15 7.05 37.225 7.425Q37.3 7.8 37.15 8.1Q36.95 8.4 36.6 8.575Q36.25 8.75 35.85 8.5Q33.2 7.1 30.2 6.375Q27.2 5.65 24.15 5.65Q21.05 5.65 18.1 6.35Q15.15 7.05 12.45 8.5Q11.95 8.75 11.6 8.65Q11.25 8.55 11.1 8.25Q10.9 8.05 10.975 7.6Q11.05 7.15 11.4 6.95Q14.3 5.3 17.575 4.5Q20.85 3.7 24.15 3.7ZM24.15 8.65Q29.5 8.65 34.25 10.975Q39 13.3 42.1 17.65Q42.4 18.1 42.325 18.475Q42.25 18.85 41.95 19.1Q41.65 19.35 41.25 19.325Q40.85 19.3 40.6 18.85Q37.8 14.9 33.425 12.775Q29.05 10.65 24.15 10.6Q19.2 10.6 14.875 12.725Q10.55 14.85 7.8 18.9Q7.45 19.35 7.05 19.425Q6.65 19.5 6.35 19.3Q6 19.15 5.925 18.775Q5.85 18.4 6 18.05Q9.05 13.6 13.85 11.125Q18.65 8.65 24.15 8.65ZM24.15 18.55Q28.8 18.55 32.125 21.725Q35.45 24.9 35.45 29.45Q35.45 29.95 35.225 30.275Q35 30.6 34.5 30.6Q33.95 30.6 33.7 30.275Q33.45 29.95 33.45 29.45Q33.45 25.65 30.725 23.05Q28 20.45 24.15 20.45Q20.3 20.45 17.6 23.15Q14.9 25.85 14.9 29.65Q14.9 33.65 16.15 36.625Q17.4 39.6 20.25 42.55Q20.6 42.9 20.6 43.25Q20.6 43.6 20.4 43.85Q20.15 44.2 19.625 44.175Q19.1 44.15 18.75 43.8Q15.9 40.8 14.425 37.35Q12.95 33.9 12.95 29.65Q12.95 25.05 16.2 21.8Q19.45 18.55 24.15 18.55ZM24.15 28.45Q24.6 28.45 24.85 28.75Q25.1 29.05 25.1 29.5Q25.1 33.9 27.975 36.2Q30.85 38.5 34.85 38.5Q35.35 38.5 36 38.4Q36.65 38.3 37.2 38.3Q37.6 38.3 37.875 38.55Q38.15 38.8 38.1 39.1Q38.1 39.5 37.925 39.725Q37.75 39.95 37.45 40.05Q36.75 40.3 36.025 40.35Q35.3 40.4 34.85 40.4Q30 40.4 26.6 37.575Q23.2 34.75 23.2 29.5Q23.2 29.05 23.45 28.75Q23.7 28.45 24.15 28.45ZM24.15 23.5Q26.7 23.5 28.5 25.225Q30.3 26.95 30.3 29.45Q30.3 31.2 31.525 32.4Q32.75 33.6 34.5 33.6Q36.2 33.6 37.4 32.4Q38.6 31.2 38.6 29.45Q38.6 23.6 34.35 19.625Q30.1 15.65 24.1 15.65Q18.1 15.65 13.9 19.725Q9.7 23.8 9.7 29.7Q9.7 31.55 9.975 33.35Q10.25 35.15 10.9 36.85Q11.05 37.35 10.925 37.65Q10.8 37.95 10.45 38.1Q10.05 38.25 9.65 38.15Q9.25 38.05 9.05 37.5Q8.55 36.05 8.175 34.025Q7.8 32 7.8 29.65Q7.8 23.1 12.625 18.325Q17.45 13.55 24.15 13.55Q30.95 13.55 35.75 18.175Q40.55 22.8 40.55 29.45Q40.55 31.95 38.8 33.75Q37.05 35.55 34.5 35.55Q31.9 35.55 30.1 33.825Q28.3 32.1 28.3 29.65Q28.3 27.9 27.1 26.65Q25.9 25.4 24.15 25.4Q22.45 25.4 21.225 26.65Q20 27.9 20 29.65Q20 34.75 22.9 38.225Q25.8 41.7 31.1 42.9Q31.55 42.95 31.725 43.275Q31.9 43.6 31.8 43.95Q31.75 44.35 31.45 44.55Q31.15 44.75 30.55 44.65Q24.7 43.45 21.375 39.375Q18.05 35.3 18.05 29.65Q18.05 27.1 19.825 25.3Q21.6 23.5 24.15 23.5Z'
			/>
		</g>
	)
});
